<template>
    <v-container fluid class="pa-0 ma-0" id="mainhomecontainer" width="100vw">
         <!-- <div class="pl-3 pt-3" style="font-size:10px;">UpdateBusiness</div> -->
         <v-card class="overview pa-3" elevation=0>
            <v-overlay v-model="overlay">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>
            <!-- <v-card-text elevation=10 class="pa-5 ma-0"> -->
                        <v-form v-model="valid" enctype="multipart/form-data" id="editbusinessregister">

        <!-- <v-container> -->

<!-- ***BUSINESS USERS & BUSINESS CONTACT DETAILS -->
                                            <v-container class="container-card-1">

<!-- DEFAULT LANGUAGE SETTINGS -->
                                            <v-card elevation=12  class="max-300 card-1 ma-1 my-4 pa-0">
                                                <v-row no-gutters class="card-header-1 pa-0 ma-0 px-3 pt-3">
                                                        <v-col cols="10" md="10" style="color:white" class="business-profile-section-heading pa-0 ma-0">
                                                            {{$t('zz_default_language')}}<br>
                                                            <span style="color:white" class="english-label">P1 UI Language</span>
                                                        </v-col>
                                                        <v-col cols="2" md="2">
                                                            <v-icon style="font-size:50px;color:white" class="pr-2">mdi-translate</v-icon>
                                                        </v-col>
                                                    </v-row>
<!-- Help Icon / dialog     -->
                                                <template>
                                                    <div>
                                                        <v-expansion-panels>
                                                        <v-expansion-panel>
                                                            <v-expansion-panel-header>
                                                            <v-icon color="#FE5800"
                                                                    style="flex:none">
                                                                mdi-information-variant
                                                                </v-icon>
                                                            </v-expansion-panel-header>
                                                            <v-expansion-panel-content class="info-dropdown">
                                                            <div v-html="$t('zz_defaul_language_explaination')">
                                                            </div>
                                                            </v-expansion-panel-content>
                                                        </v-expansion-panel>
                                                        </v-expansion-panels>
                                                    </div>
                                                </template>
<!-- Help Icon / dialog                                                          -->
                                                    <!-- <v-row> -->
                                                        <v-row class="pa-0 ma-0 px-3">
                                                            <v-col cols="12" md="12">
                                                                <v-row>
                                                                    <v-col cols="4" md="4">
                                                                        <div class="">
                                                                            <v-dialog style="position:relative" v-model="dialog" width="800">
                                                                                <template v-slot:activator="{ on, attrs }">
                                                                                    <v-btn
                                                                                    elevation="2"
                                                                                    color="#FE5800"
                                                                                    fab
                                                                                    x-small
                                                                                    v-bind="attrs"
                                                                                    v-on="on"
                                                                                    >
                                                                                        <v-icon color="white">mdi-information-variant</v-icon>
                                                                                    </v-btn>
                                                                                </template>
                                                                                <v-card>
                                                                                    <v-icon style="position:absloute; justify-content:flex-end; top:12px; right:12px" color="white" icon dark  class="close" @click="dialog = false">mdi-close-circle</v-icon>
                                                                                    <v-card-title class="text-h1 zzorganebg">
                                                                                        <span class="dialog-title"><v-icon style="font-size:50px;color:white" class="pr-2">mdi-earth</v-icon>{{$t('zz_defaul_language_title')}}</span>
                                                                                    </v-card-title>
                                                                                    <p class="pt-5 px-4">
                                                                                        <span v-html="$t('zz_defaul_language_explaination')">
                                                                                        </span>
                                                                                    </p><br>
                                                                                    <v-divider></v-divider>
                                                                                    <p class="pt-5 px-4"><span v-html="$t('zz_remember_to_save')"></span></p><br>
                                                                                </v-card>
                                                                            </v-dialog>
                                                                        </div>
                                                                    </v-col>
                                                                    <v-col cols="8" md="8">
                                                                        <v-autocomplete
                                                                            label="Languages"
                                                                            v-model="languages"
                                                                            name="languages"
                                                                            item-text="name"
                                                                            item-value="code"
                                                                            :items="lang"
                                                                            @change="fetchLangCode"
                                                                            dense
                                                                            >
                                                                        </v-autocomplete>
                                                                    </v-col>
                                                                </v-row>
                                                            </v-col>
                                                        </v-row>
                                                    <!-- </v-row> -->
                                            </v-card>

<!-- USER ACCOUNT   -->
                                                <v-card elevation=12  class="max-300 card-1 ma-1 my-4 pa-0">
                                                    <v-row no-gutters class="card-header-1 pa-0 ma-0 px-3 pt-3">
                                                        <v-col cols="10" md="10" style="color:white" class="business-profile-section-heading pa-0 ma-0">
                                                            {{$t('zz_user_account_details')}}<br>
                                                            <span style="color:white" class="english-label">P2 User Account Details</span>
                                                        </v-col>
                                                        <v-col cols="2" md="2" class="pa-0 ma-0">
                                                            <v-icon style="font-size:40px;color:white">mdi-account</v-icon>
                                                        </v-col>
                                                    </v-row>
<!-- Help Icon / dialog     -->
                                                <template>
                                                    <div>
                                                        <v-expansion-panels>
                                                            <v-expansion-panel>
                                                                <v-expansion-panel-header>
                                                                    <v-icon color="#FE5800"
                                                                        style="flex:none">
                                                                    mdi-information-variant
                                                                    </v-icon>
                                                                </v-expansion-panel-header>
                                                                <v-expansion-panel-content class="info-dropdown">
                                                                    <div v-html="$t('zz_private_info')">
                                                                    </div>
                                                                </v-expansion-panel-content>
                                                            </v-expansion-panel>
                                                        </v-expansion-panels>
                                                    </div>
                                                </template>
                                                    <v-row>
                                                        <v-col col="auto" v-if="contactimg">
                                                        <v-container class="true-center">
                                                        <v-img elevation="12" :src="contactimg"
                                                                max-height="150px"
                                                                max-width="150px"
                                                                class="profile-pic grey lighten-2" v-if="contactimg!=null" />
                                                        <v-icon style="position:relative; top:5px; left:0px" color="red" icon dark  class="" @click="delelteContactImage()">mdi-close-circle</v-icon>
                                                        </v-container>

                                                        </v-col>
                                                        <v-col cols="12" md="12" sm="12">
                                                            <v-row v-if="contactimguploading">
                                                                <v-col cols="12" class="text-center">
                                                                    <v-progress-circular
                                                                        indeterminate
                                                                        color="primary"
                                                                    ></v-progress-circular>
                                                                </v-col>
                                                            </v-row>

                                                            <Cropper
                                                            v-show="contactimage!=null && contactimage!='null'"
                                                            classname="cropper" :src="contactimage" @change="onChangeContactImage($event)" :stencilProps="{aspectRatio: 1}"/>
                                                            <v-row>
                                                                <v-col cols="12" md="12" sm="12" align="center">
                                                                <span @click="$refs.contactimgfile.click()" style="color:#FE5800" class="">{{$t('zz_add_profile_photo')}}<v-icon class="pr-1 addnewicon">mdi-plus-circle-outline</v-icon></span>

                                                                <!-- <v-btn small color="primary" @click="$refs.contactimgfile.click()">
                                                                    <input type="file" ref="contactimgfile" @change="contactim($event)" accept="image/*" class="d-none" id="contactimg"/>{{$t('zz_add_profile_photo')}}
                                                                </v-btn> -->
                                                                </v-col>
                                                            </v-row>
                                                        </v-col>
                                                    </v-row>

                                                    <v-row no-gutters class="py-3 ma-0">
                                                        <v-col cols="6" md="6" class="px-3">
                                                            <v-text-field
                                                            v-model="storeBusiness.contactFirstName"
                                                            label="First Name"
                                                            name="contactFirstName"
                                                            type="text"
                                                            v-validate="'required'"
                                                            :error-messages="errors.collect('contactFirstName')"
                                                            data-vv-name="contactFirstName"
                                                            required
                                                            dense

                                                            ></v-text-field>
                                                        </v-col>
                                                        <v-col cols="6" md="6" class="px-3">
                                                            <v-text-field
                                                            v-model="storeBusiness.contactLastName"
                                                            label="Last Name"
                                                            name="contactLastName"
                                                            type="text"
                                                            v-validate="'required'"
                                                            :error-messages="errors.collect('contactLastName')"
                                                            data-vv-name="contactLastName"
                                                            required
                                                            dense

                                                            ></v-text-field>
                                                        </v-col>
                                                        <v-col cols="12" md="12" class="px-3">
                                                            <v-text-field
                                                            v-model="storeBusiness.contactPosition"
                                                            label="Contact Position"
                                                            name="contactPosition"
                                                            type="text"
                                                            dense

                                                            ></v-text-field>
                                                        </v-col>
                                                        <v-col cols="12" md="12" class="px-3">
                                                            <v-text-field
                                                            v-model="storeBusiness.contactPhone"
                                                            label="Contact Phone"
                                                            name="contactPhone"
                                                            type="tel"
                                                            dense

                                                            ></v-text-field>
                                                        </v-col>

                                                        <v-col cols="12" md="12" class="px-3">
                                                            <v-text-field
                                                                v-model="email"
                                                                name="email"
                                                                label="User Email"
                                                                type="email"

                                                                required
                                                                v-validate="'required|email'"
                                                                :error-messages="errors.collect('email')"
                                                                data-vv-name="email"
                                                                dense

                                                            ></v-text-field>
                                                        </v-col>

                                                        <!-- <v-col cols="12" md="12">

                                                            <v-row align="center">
                                                                <v-col cols="9" md="9" class="font-weight-bold" style="font-size:18px;" >
                                                                    Tax Payable
                                                                </v-col>
                                                                <v-col cols="3" md="3">
                                                                    <v-switch label="" v-model="taxpayable" color="success"></v-switch>
                                                                </v-col>
                                                            </v-row>
                                                        </v-col> -->




                                                    </v-row>
                                                </v-card>

<!-- BUSINESS ADDRESS -->
                                                <v-card elevation=12  class="max-300 card-1 ma-1 my-4 pa-0">
                                                    <v-row no-gutters class="card-header-1 pa-0 ma-0 px-3 pt-3">
                                                        <v-col cols="10" md="10" style="color:white" class="business-profile-section-heading pa-0 ma-0">
                                                            {{$t('zz_business_details')}}<br>
                                                            <span style="color:white" class="english-label">P3 Business Details</span>
                                                        </v-col>
                                                        <v-col cols="2" md="2" class="pa-0 ma-0">
                                                            <v-icon style="font-size:40px;color:white">mdi-map-marker-radius</v-icon>
                                                        </v-col>

                                                    </v-row>
                                                        <!-- Help Icon / dialog     -->
                                                    <template>
                                                        <div>
                                                            <v-expansion-panels>
                                                                <v-expansion-panel>
                                                                    <v-expansion-panel-header>
                                                                        <v-icon color="#FE5800"
                                                                            style="flex:none">
                                                                        mdi-information-variant
                                                                        </v-icon>
                                                                    </v-expansion-panel-header>
                                                                    <v-expansion-panel-content class="info-dropdown">
                                                                        <div v-html="$t('zz_public_info')">
                                                                        </div>
                                                                    </v-expansion-panel-content>
                                                                </v-expansion-panel>
                                                            </v-expansion-panels>
                                                        </div>
                                                    </template>
                                                    <v-row class="pa-3 ma-0">
                                                        <v-col cols="12" md="12">
                                                            <v-text-field
                                                            v-model="businessName"
                                                            label="Business Name"
                                                            name="businessName"
                                                            type="text"
                                                            v-validate="'required'"
                                                            :error-messages="errors.collect('businessName')"
                                                            data-vv-name="businessName"
                                                            required
                                                            outlined
                                                            ></v-text-field>
                                                        </v-col>
                                                    </v-row>
                                                    <v-row class="pa-3 ma-0">
                                                        <v-col cols="12" md="12">
                                                            <v-text-field
                                                            v-model="storeBusiness.addressLine1"
                                                            label="Business Address"
                                                            name="addressLine1"
                                                            type="text"
                                                            dense

                                                            ></v-text-field>
                                                        </v-col>
                                                        <v-col cols="12" md="12">
                                                            <v-text-field
                                                            v-model="storeBusiness.addressLine2"
                                                            label="Business Address2"
                                                            name="addressLine2"
                                                            type="text"
                                                            dense

                                                            ></v-text-field>
                                                        </v-col>
                                                        <v-col cols="12" md="12">
                                                            <v-text-field
                                                            v-model="storeBusiness.addressLine3"
                                                            label="City/Town"
                                                            name="addressLine3"
                                                            type="text"
                                                            dense

                                                            ></v-text-field>
                                                        </v-col>
                                                        <v-col cols="12" md="12">
                                                            <v-text-field
                                                            v-model="storeBusiness.addressLine4"
                                                            label="State/Province/Region"
                                                            name="addressLine4"
                                                            type="text"
                                                            dense

                                                            ></v-text-field>
                                                        </v-col>
                                                        <!-- <v-col cols="12" md="12">
                                                            <v-text-field
                                                            v-model="storeBusiness.country"
                                                            label="Country"
                                                            name="country"
                                                            type="text"
                                                            dense

                                                            ></v-text-field>
                                                        </v-col> -->
                                                        <v-col cols="12" md="12" class="px-3">
                                                            <v-autocomplete
                                                            dense
                                                            label="Country"
                                                            autocomplete="off"
                                                            v-model="storeBusiness.country"
                                                            name="country"
                                                            item-text="name"
                                                            item-value="name"
                                                            :items="countries"
                                                            >
                                                            </v-autocomplete>
                                                        </v-col>
                                                        <v-col cols="12" md="12">
                                                            <v-text-field
                                                            v-model="storeBusiness.postcode"
                                                            label="Postal Code"
                                                            name="postcode"
                                                            type="text"
                                                            dense

                                                            ></v-text-field>
                                                        </v-col>
                                                    </v-row>
                                                </v-card>

                                                <!-- Business Billing Details -->
                                                <v-card elevation=12  class="max-300 card-1 ma-1 my-4 pa-0">
                                                    <v-row no-gutters class="card-header-1 pa-0 ma-0 px-3 pt-3">
                                                        <v-col cols="10" md="10" style="color:white" class="business-profile-section-heading pa-0 ma-0">
                                                            {{ $t('zz_billing_heading') }}<br>
                                                            <span style="color:white" class="english-label">P4 Billing Details</span>
                                                        </v-col>
                                                        <v-col cols="2" md="2" class="pa-0 ma-0">
                                                            <v-icon style="font-size:40px;color:white">mdi-map-marker-radius</v-icon>
                                                        </v-col>

                                                    </v-row>
                                                    <template>
                                                        <div>
                                                            <v-expansion-panels>
                                                                <v-expansion-panel>
                                                                    <v-expansion-panel-header>
                                                                        <v-icon color="#FE5800"
                                                                            style="flex:none">
                                                                        mdi-information-variant
                                                                        </v-icon>
                                                                    </v-expansion-panel-header>
                                                                    <v-expansion-panel-content class="info-dropdown">
                                                                        <div v-html="$t('zz_billing_explainer')">
                                                                        </div>
                                                                    </v-expansion-panel-content>
                                                                </v-expansion-panel>
                                                            </v-expansion-panels>
                                                        </div>
                                                    </template>

                                                    <v-row class="pa-3 ma-0">

                                                        <v-col cols="12" md="12">

                                                            <v-text-field
                                                            v-model="billing_business_name"
                                                            name="billing_business_name"
                                                        :label="$t('zz_billing_bus_name')"
                                                            autocomplete="billing_business_name"
                                                            type="text"
                                                            dense
                                                            outlined
                                                            ></v-text-field>
                                                            <v-text-field
                                                            v-model="billing_contactname"
                                                            name="billing_contactname"
                                                        :label="$t('zz_billing_contact_name')"
                                                            autocomplete="billing_contactname"
                                                            type="text"
                                                            dense
                                                            outlined
                                                            ></v-text-field>

                                                            <v-text-field
                                                            v-model="billing_contactnumber"
                                                            name="billing_contactnumber"
                                                        :label="$t('zz_billing_contact_number')"
                                                            autocomplete="billing_contactnumber"
                                                            type="text"
                                                            dense
                                                            outlined
                                                            ></v-text-field>

                                                            <v-text-field
                                                            v-model="billing_email"
                                                            name="billing_email"
                                                        :label="$t('zz_billing_email')"
                                                            autocomplete="billing_email"
                                                            type="text"
                                                            dense
                                                            outlined
                                                            ></v-text-field>

                                                            <!-- <v-text-field
                                                            v-model="billing_country"
                                                            name="billing_country"
                                                            :label="$t('zz_billing_country')"
                                                            autocomplete="billing_country"
                                                            type="text"
                                                            dense
                                                            outlined
                                                            ></v-text-field> -->

                                                            <v-autocomplete
                                                            dense
                                                            label="Country"
                                                            autocomplete="off"
                                                            v-model="billing_country"
                                                            name="billing_country"
                                                            item-text="name"
                                                            item-value="name"
                                                            :items="countries"
                                                            >
                                                            </v-autocomplete>

                                                            <v-text-field
                                                            v-model="billing_taxcode"
                                                            name="billing_taxcode"
                                                        :label="$t('zz_billing_tax_number')"
                                                            autocomplete="billing_taxcode"
                                                            type="text"
                                                            dense
                                                            outlined
                                                            ></v-text-field>

                                                            <v-text-field
                                                            v-model="billing_address1"
                                                            name="billing_address1"
                                                        :label="$t('zz_billing_add1')"
                                                            autocomplete="billing_address1"
                                                            type="text"
                                                            dense
                                                            outlined
                                                            ></v-text-field>

                                                            <v-text-field
                                                            v-model="billing_address2"
                                                            name="billing_address2"
                                                        :label="$t('zz_billing_add2')"
                                                            autocomplete="billing_address2"
                                                            type="text"
                                                            dense
                                                            outlined
                                                            ></v-text-field>

                                                            <v-text-field
                                                            v-model="billing_address3"
                                                            name="billing_address3"
                                                        :label="$t('zz_billing_add3')"
                                                            autocomplete="billing_address3"
                                                            type="text"
                                                            dense
                                                            outlined
                                                            ></v-text-field>

                                                            <v-text-field
                                                            v-model="billing_address4"
                                                            name="billing_address4"
                                                        :label="$t('zz_billing_add4')"
                                                            autocomplete="billing_address4"
                                                            type="text"
                                                            dense
                                                            outlined
                                                            ></v-text-field>

                                                            <v-text-field
                                                            v-model="billing_postalcode"
                                                            name="billing_postalcode"
                                                        :label="$t('zz_billing_post_code')"
                                                            autocomplete="billing_postalcode"
                                                            type="text"
                                                            dense
                                                            outlined
                                                            ></v-text-field>
                                                        </v-col>

                                                    </v-row>

                                                </v-card>

<!-- BUSINESS CONTACTS -->
                                                <v-card elevation=12 class="max-300 card-1 ma-1 my-4 pa-0">
                                                    <v-row no-gutters class="card-header-1 pa-0 ma-0 px-3 pt-3">
                                                        <v-col cols="10" md="10" style="color:white" class="business-profile-section-heading pa-0 ma-0">
                                                            {{$t('zz_contacts')}}<br>
                                                            <span style="color:white" class="english-label">P5 Business Contact Details</span>
                                                        </v-col>
                                                        <v-col cols="2" md="2" class="pa-0 ma-0">
                                                            <v-icon style="font-size:40px;color:white">mdi-phone</v-icon>
                                                        </v-col>
                                                    </v-row>
<!-- Help Icon / dialog     -->
                                                    <template>
                                                        <div>
                                                            <v-expansion-panels>
                                                                <v-expansion-panel>
                                                                    <v-expansion-panel-header>
                                                                        <v-icon color="#FE5800"
                                                                            style="flex:none">
                                                                        mdi-information-variant
                                                                        </v-icon>
                                                                    </v-expansion-panel-header>
                                                                    <v-expansion-panel-content class="info-dropdown">
                                                                        <div v-html="$t('zz_public_info')">
                                                                        </div>
                                                                    </v-expansion-panel-content>
                                                                </v-expansion-panel>
                                                            </v-expansion-panels>
                                                        </div>
                                                    </template>
                                                    <v-row class="pa-3 ma-0">
                                                        <v-col cols="12" md="12">
                                                            <v-text-field
                                                            outlined
                                                            dense
                                                            v-model="this.data.ownername"
                                                            name="ownername"
                                                            label="Business Owner Name"
                                                            ></v-text-field>
                                                        </v-col>
                                                        <v-col cols="12" md="12">
                                                            <v-text-field
                                                                dense
                                                                v-model="numberOfEmployees"
                                                                name="numberOfEmployees"
                                                                label="No. Of Employees"

                                                            ></v-text-field>
                                                        </v-col>

                                                        <!-- <v-col cols="12" md="12">
                                                            <v-text-field

                                                                dense
                                                                v-model="this.data.ownerposition"
                                                                name="ownerposition"
                                                                label="Owner Position">
                                                            </v-text-field>
                                                        </v-col> -->
                                                        <v-col cols="12" md="12">
                                                            <v-text-field
                                                            v-model="storeBusiness.phone"
                                                            label="Landline"
                                                            name="phone"
                                                            type="tel"
                                                            dense

                                                            ></v-text-field>
                                                        </v-col>
                                                        <v-col cols="12" md="12">
                                                            <v-text-field
                                                            v-model="storeBusiness.mobile"
                                                            label="Mobile(+34)"
                                                            name="mobile"
                                                            type="tel"
                                                            dense

                                                            ></v-text-field>
                                                        </v-col>
                                                        <v-col cols="12" md="12">
                                                            <v-text-field
                                                            v-model="storeBusiness.whatsapp"
                                                            label="whatsapp(+34)"
                                                            name="whatsapp"
                                                            type="tel"
                                                            dense

                                                            ></v-text-field>
                                                        </v-col>
                                                        <v-col cols="12" md="12">
                                                            <v-text-field
                                                            v-model="storeBusiness.contactEmail"
                                                            name="contactEmail"
                                                            label="Contact Email"
                                                            dense

                                                            >
                                                            </v-text-field>
                                                        </v-col>
                                                        <v-col cols="12" md="12">
                                                            <v-text-field
                                                            v-model="storeBusiness.website"
                                                            label="website"
                                                            name="website"
                                                            type="text"
                                                            dense

                                                            ></v-text-field>
                                                        </v-col>

                                                    </v-row>
                                                </v-card>

<!-- BUSINESS PAYMENTS  -->
                                            <v-card elevation=12  class="max-300 card-1 ma-1 my-4 pa-0">
                                                <v-row no-gutters class="card-header-1 pa-0 ma-0 px-3 pt-3">
                                                    <v-col cols="10" md="10" style="color:white" class="business-profile-section-heading pa-0 ma-0">
                                                        {{$t('zz_payments_transactions')}}<br>
                                                        <span style="color:white" class="english-label">P6 Payments & Transactions</span>
                                                    </v-col>
                                                    <v-col cols="2" md="2">
                                                        <v-icon style="font-size:50px;color:white" class="pr-2">mdi-currency-eur</v-icon>
                                                    </v-col>
                                                </v-row>
                                                <template>
                                                    <div>
                                                        <v-expansion-panels>
                                                        <v-expansion-panel>
                                                            <v-expansion-panel-header>
                                                            <v-icon color="#FE5800"
                                                                    style="flex:none">
                                                                mdi-information-variant
                                                                </v-icon>
                                                            </v-expansion-panel-header>
                                                            <v-expansion-panel-content class="info-dropdown">
                                                            <div v-html="$t('zz_stripe_explained')">
                                                            </div>
                                                            <!-- <span class="">
                                                                {{$t('zz_payments_transactions')}} {{$t('zz_explained')}}<br>
                                                                {{$t('zz_stripe_explained')}}
                                                            </span> -->

                                                            </v-expansion-panel-content>
                                                        </v-expansion-panel>
                                                        </v-expansion-panels>
                                                    </div>
                                                </template>
                                                <v-row align="center" class="pa-0 ma-0">
                                                    <v-col cols="9" md="9" class="font-weight-bold pa-0 ma-0 px-3" style="font-size:18px;" >
                                                        <v-img :src="stripelogo" style="width:100px"></v-img>
                                                    </v-col>
                                                    <v-col cols="3" md="3" v-if="paymentenabled">
                                                        <v-switch label="" :input-value="payshw" v-model="paymentenabled" color="success"></v-switch>
                                                    </v-col>
                                                    <v-col cols="3" md="3" v-else>
                                                        <v-switch label="" :input-value="paynshw" v-model="paymentenabled" color="success"></v-switch>
                                                    </v-col>
                                                </v-row>
                                                <v-row v-show="paymentenabled" class="pa-3 ma-0 px-3">
                                                    <v-col cols="12" md="12">
                                                        <v-text-field
                                                        v-model="stripapikey"
                                                        label="Stripe Api Key"
                                                        name="stripapikey"
                                                        type="text"
                                                        dense

                                                        ></v-text-field>
                                                    </v-col>
                                                    <v-col cols="12" md="12">
                                                        <v-text-field
                                                        v-model="stripsecretkey"
                                                        label="Stripe Secret Key"
                                                        name="stripsecretkey"
                                                        type="text"
                                                        dense

                                                        ></v-text-field>
                                                    </v-col>
                                                </v-row>
                                            </v-card>

                                            </v-container>

                                            <!-- ****HOURS & DATES  -->
                                            <v-container class="container-card-1">
                                                <v-card elevation=0 class="pa-3">
                                                    <v-row no-gutters class="card-header-1 pa-0 ma-0 px-3 pt-3">
                                                        <v-col cols="10" md="10" style="color:white" class="business-profile-section-heading pa-0 ma-0">
                                                            {{$t('zz_business_details')}}<br>
                                                            <span style="color:white" class="english-label">P7 Business Operations</span>
                                                        </v-col>
                                                        <v-col cols="2" md="2">
                                                            <v-icon style="font-size:50px;color:white" class="pr-2">mdi-calendar-clock</v-icon>
                                                        </v-col>
                                                    </v-row>

                                                    <!-- BUSINESS SEASON  -->
                                                    <v-card elevation=12 class="card-1 ma-1 my-4 pa-0" style="height:fit-content">
                                                        <!-- Heading                                                -->
                                                        <v-row no-gutters class="card-header-1 pa-0 ma-0 px-3 pt-3">
                                                            <v-col cols="10" md="10" style="color:white" class="business-profile-section-heading pa-0 ma-0">
                                                                {{$t('zz_season_dates')}}<br>
                                                                <span style="color:white" class="english-label">P7.1 Business Season</span>
                                                            </v-col>
                                                            <v-col cols="2" md="2">
                                                                <v-icon style="font-size:40px;color:white">mdi-calendar-month-outline</v-icon>
                                                            </v-col>
                                                        </v-row>
                                                        <!-- Help Icon / dialog     -->
                                                        <template>
                                                            <div>
                                                                <v-expansion-panels>
                                                                    <v-expansion-panel>
                                                                        <v-expansion-panel-header>
                                                                            <v-icon color="#FE5800"
                                                                                style="flex:none">
                                                                            mdi-information-variant
                                                                            </v-icon>
                                                                        </v-expansion-panel-header>
                                                                        <v-expansion-panel-content class="info-dropdown">
                                                                            <div v-html="$t('zz_seasonal_explainer')">
                                                                            </div>
                                                                        </v-expansion-panel-content>
                                                                    </v-expansion-panel>
                                                                </v-expansion-panels>
                                                            </div>
                                                        </template>
                                                        <v-col cols="4" md="4" sm="4"class="biz-hours-day">
                                                            <v-checkbox v-model="openallyear" @click="setopenallyear()" :label="$t('zz_open_all_year')"></v-checkbox>
                                                        </v-col>
                                                    <!-- <v-container v-if="openallyear=='openallyear'" cols="12" class=""> -->
                                                    <v-container  cols="12" class="biz-hours-container">
        <!-- Dates From - To                                                             -->
                                                        <v-row>
                                                            <v-col cols="4" md="4" sm="4" class="px-3 biz-hours-day">
                                                                <v-menu
                                                                    v-model="menu2"
                                                                    :close-on-content-click="false"

                                                                    transition="scale-transition"
                                                                    offset-y
                                                                    min-width="290px">
                                                                    <template v-slot:activator="{ on }">

                                                                    <v-text-field
                                                                        v-model="computedDateFormatted"
                                                                        label="Start Date"
                                                                        prepend-icon="event"
                                                                        hint="DD/MM/YYYY"
                                                                        persistent-hint
                                                                        readonly
                                                                        v-on="on"
                                                                    ></v-text-field>
                                                                    </template>

                                                                    <v-date-picker v-model="fromdate" name="fromdate"  @input="menu2 = false"></v-date-picker>
                                                                </v-menu>
                                                            </v-col>

                                                            <v-col cols="12" md="4" sm="4"class="px-3 biz-hours-day">
                                                            <v-menu
                                                                v-model="menu3"
                                                                :close-on-content-click="false"
                                                                transition="scale-transition"
                                                                offset-y min-width="290px">
                                                                <template v-slot:activator="{ on }">

                                                                <v-text-field
                                                                    v-model="computedDateFormattedEnd"
                                                                    label="End Date"
                                                                    prepend-icon="event"
                                                                    hint="DD/MM/YYYY"
                                                                    persistent-hint
                                                                    readonly
                                                                    v-on="on"
                                                                ></v-text-field>
                                                                </template>
                                                                <v-date-picker v-model="enddate" name="enddate"  @input="menu3 = false"></v-date-picker>
                                                            </v-menu>
                                                            </v-col>
                                                        </v-row>
                                                    </v-container>
                                                    </v-card>

    <!-- BUSINESS HOURS  -->
                                                    <v-card elevation=12 class="card-1 ma-1 my-4 pa-0" style="height:fit-content">
            <!-- Heading                                                -->
                                                            <v-row no-gutters class="card-header-1 pa-0 ma-0 px-3 pt-3">

                                                            <v-col cols="10" md="10" style="color:white" class="business-profile-section-heading pa-0 ma-0">
                                                                {{$t('zz_business_hours')}}<br>
                                                                <span style="color:white" class="english-label">P7.2 Business Hours</span>
                                                            </v-col>
                                                            <v-col cols="2" md="2">
                                                                <v-icon style="font-size:40px;color:white">mdi-clock</v-icon>
                                                            </v-col>
                                                        </v-row>
<!-- Help Icon / dialog     -->
                                                        <template>
                                                            <div>
                                                                <v-expansion-panels>
                                                                    <v-expansion-panel>
                                                                        <v-expansion-panel-header>
                                                                            <v-icon color="#FE5800"
                                                                                style="flex:none">
                                                                            mdi-information-variant
                                                                            </v-icon>
                                                                        </v-expansion-panel-header>
                                                                        <v-expansion-panel-content class="info-dropdown">
                                                                            <div v-html="$t('zz_business_hours_explainer')">
                                                                            </div>
                                                                        </v-expansion-panel-content>
                                                                    </v-expansion-panel>
                                                                </v-expansion-panels>
                                                            </div>
                                                        </template>
        <!-- OPEN 24 Hrs Always Open                                                 -->
                                                        <v-col cols="4" md="4" sm="4" class="biz-hours-day">

                                                            <v-checkbox v-model="alwaysopen" @click="setalwaysopen()" :label="$t('zz_always_open')"></v-checkbox>
                                                        </v-col>
                                                        <v-container v-if="alwaysopen==''" cols="12" class="">

        <!-- Monday     -->
                                                            <v-container class="ma-0 pa-0 biz-hours-container">
                                                                <v-row>
                                                                    <v-col class="ma-0 pa-0 biz-hours-container">
                                                                        <div class="biz-hours-day">
                                                                            <v-tooltip bottom>
                                                                                <template v-slot:activator="{ on, attrs }">
                                                                                    <v-btn
                                                                                    small
                                                                                    class="ma-1 px-1"
                                                                                    color="#FE5800"
                                                                                    @click="mondayTime"
                                                                                    v-bind="attrs"
                                                                                    v-on="on"
                                                                                    >
                                                                                    <v-icon
                                                                                    color="white"
                                                                                    >
                                                                                    mdi-clipboard-arrow-down-outline
                                                                                    </v-icon>
                                                                                    </v-btn>
                                                                                </template>
                                                                                <span>{{$t('zz_copy-to-next-line')}}</span>
                                                                            </v-tooltip>

                                                                            <span class="capitalised">{{$t('zz_monday')}}</span>
                                                                        </div>
                                                                    </v-col>
                                                                    <v-col class="biz-hours-container" >

                                                                        <div class="biz-hours-row">
                                                                            <v-autocomplete
                                                                            :label="$t('zz_open_am')"
                                                                            v-model="storeBusiness.mondayopening"
                                                                            name="mondayopening"
                                                                            item-text="name"
                                                                            item-value="value"
                                                                            :items="times"
                                                                            :disabled="alwaysopen"
                                                                            ></v-autocomplete>
                                                                        </div>
                                                                        <div class="biz-hours-row">
                                                                            <v-autocomplete
                                                                            :label="$t('zz_close_am')"
                                                                            v-model="storeBusiness.mondayclosing"
                                                                            name="mondayclosing"
                                                                            item-text="name"
                                                                            item-value="value"
                                                                            :items="times"
                                                                            :disabled="alwaysopen"
                                                                            ></v-autocomplete>
                                                                        </div>

                                                                        <div class="biz-hours-row">
                                                                            <v-autocomplete
                                                                            :label="$t('zz_open_pm')"
                                                                            v-model="storeBusiness.mondayopening2"
                                                                            name="mondayopening2"
                                                                            item-text="name"
                                                                            item-value="value"
                                                                            :items="times"
                                                                            :disabled="alwaysopen"
                                                                            ></v-autocomplete>
                                                                        </div>
                                                                        <div class="biz-hours-row">
                                                                            <v-autocomplete
                                                                            :label="$t('zz_close_pm')"
                                                                            v-model="storeBusiness.mondayclosing2"
                                                                            name="mondayclosing2"
                                                                            item-text="name"
                                                                            item-value="value"
                                                                            :items="times"
                                                                            :disabled="alwaysopen"
                                                                            ></v-autocomplete>
                                                                        </div>

                                                                    </v-col>
                                                                </v-row>
                                                            </v-container>
                                                            <v-divider></v-divider>

        <!-- Tuesday     -->
                                                            <v-container class="ma-0 pa-0 biz-hours-container">
                                                                <v-row>
                                                                    <v-col class="ma-0 pa-0 biz-hours-container">
                                                                        <div class="biz-hours-day">
                                                                            <v-tooltip bottom>
                                                                                <template v-slot:activator="{ on, attrs }">
                                                                                    <v-btn
                                                                                    small
                                                                                    class="ma-1 px-1"
                                                                                    color="#FE5800"
                                                                                    @click="tuesdayTime"
                                                                                    v-bind="attrs"
                                                                                    v-on="on"
                                                                                    >
                                                                                    <v-icon
                                                                                    color="white"
                                                                                    >
                                                                                    mdi-clipboard-arrow-down-outline
                                                                                    </v-icon>
                                                                                    </v-btn>
                                                                                </template>
                                                                                <span>{{$t('zz_copy-to-next-line')}}</span>
                                                                            </v-tooltip>

                                                                            <span class="capitalised">{{$t('zz_tuesday')}}</span>
                                                                        </div>
                                                                    </v-col>
                                                                    <v-col class="biz-hours-container" >

                                                                        <div class="biz-hours-row">
                                                                            <v-autocomplete
                                                                            :label="$t('zz_open_am')"
                                                                            v-model="storeBusiness.tuesdayopening"
                                                                            name="tuesdayopening"
                                                                            item-text="name"
                                                                            item-value="value"
                                                                            :items="times"
                                                                            :disabled="alwaysopen"
                                                                            ></v-autocomplete>
                                                                        </div>
                                                                        <div class="biz-hours-row">
                                                                            <v-autocomplete
                                                                            :label="$t('zz_close_am')"
                                                                            v-model="storeBusiness.tuesdayclosing"
                                                                            name="tuesdayclosing"
                                                                            item-text="name"
                                                                            item-value="value"
                                                                            :items="times"
                                                                            :disabled="alwaysopen"
                                                                            ></v-autocomplete>
                                                                        </div>

                                                                        <div class="biz-hours-row">
                                                                            <v-autocomplete
                                                                            :label="$t('zz_open_pm')"
                                                                            v-model="storeBusiness.tuesdayopening2"
                                                                            name="tuesdayopening2"
                                                                            item-text="name"
                                                                            item-value="value"
                                                                            :items="times"
                                                                            :disabled="alwaysopen"
                                                                            ></v-autocomplete>
                                                                        </div>
                                                                        <div class="biz-hours-row">
                                                                            <v-autocomplete
                                                                            :label="$t('zz_close_pm')"
                                                                            v-model="storeBusiness.tuesdayclosing2"
                                                                            name="tuesdayclosing2"
                                                                            item-text="name"
                                                                            item-value="value"
                                                                            :items="times"
                                                                            :disabled="alwaysopen"
                                                                            ></v-autocomplete>
                                                                        </div>

                                                                    </v-col>
                                                                </v-row>
                                                            </v-container>
                                                            <v-divider></v-divider>

        <!-- Wednesday     -->
                                                            <v-container class="ma-0 pa-0 biz-hours-container">
                                                                <v-row>
                                                                    <v-col class="ma-0 pa-0 biz-hours-container">
                                                                        <div class="biz-hours-day">
                                                                            <v-tooltip bottom>
                                                                                <template v-slot:activator="{ on, attrs }">
                                                                                    <v-btn
                                                                                    small
                                                                                    class="ma-1 px-1"
                                                                                    color="#FE5800"
                                                                                    @click="wednesdayTime"
                                                                                    v-bind="attrs"
                                                                                    v-on="on"
                                                                                    >
                                                                                    <v-icon
                                                                                    color="white"
                                                                                    >
                                                                                    mdi-clipboard-arrow-down-outline
                                                                                    </v-icon>
                                                                                    </v-btn>
                                                                                </template>
                                                                                <span>{{$t('zz_copy-to-next-line')}}</span>
                                                                            </v-tooltip>

                                                                            <span class="capitalised">{{$t('zz_wednesday')}}</span>
                                                                        </div>
                                                                    </v-col>
                                                                    <v-col class="biz-hours-container" >

                                                                        <div class="biz-hours-row">
                                                                            <v-autocomplete
                                                                            :label="$t('zz_open_am')"
                                                                            v-model="storeBusiness.wednesdayopening"
                                                                            name="wednesdayopening"
                                                                            item-text="name"
                                                                            item-value="value"
                                                                            :items="times"
                                                                            :disabled="alwaysopen"
                                                                            ></v-autocomplete>
                                                                        </div>
                                                                        <div class="biz-hours-row">
                                                                            <v-autocomplete
                                                                            :label="$t('zz_close_am')"
                                                                            v-model="storeBusiness.wednesdayclosing"
                                                                            name="wednesdayclosing"
                                                                            item-text="name"
                                                                            item-value="value"
                                                                            :items="times"
                                                                            :disabled="alwaysopen"
                                                                            ></v-autocomplete>
                                                                        </div>

                                                                        <div class="biz-hours-row">
                                                                            <v-autocomplete
                                                                            :label="$t('zz_open_pm')"
                                                                            v-model="storeBusiness.wednesdayopening2"
                                                                            name="wednesdayopening2"
                                                                            item-text="name"
                                                                            item-value="value"
                                                                            :items="times"
                                                                            :disabled="alwaysopen"
                                                                            ></v-autocomplete>
                                                                        </div>
                                                                        <div class="biz-hours-row">
                                                                            <v-autocomplete
                                                                            :label="$t('zz_close_pm')"
                                                                            v-model="storeBusiness.wednesdayclosing2"
                                                                            name="wednesdayclosing2"
                                                                            item-text="name"
                                                                            item-value="value"
                                                                            :items="times"
                                                                            :disabled="alwaysopen"
                                                                            ></v-autocomplete>
                                                                        </div>

                                                                    </v-col>
                                                                </v-row>
                                                            </v-container>
                                                            <v-divider></v-divider>

        <!-- Thursday     -->
                                                            <v-container class="ma-0 pa-0 biz-hours-container">
                                                                <v-row>
                                                                    <v-col class="ma-0 pa-0 biz-hours-container">
                                                                        <div class="biz-hours-day">
                                                                            <v-tooltip bottom>
                                                                                <template v-slot:activator="{ on, attrs }">
                                                                                    <v-btn
                                                                                    small
                                                                                    class="ma-1 px-1"
                                                                                    color="#FE5800"
                                                                                    @click="thursdayTime"
                                                                                    v-bind="attrs"
                                                                                    v-on="on"
                                                                                    >
                                                                                    <v-icon
                                                                                    color="white"
                                                                                    >
                                                                                    mdi-clipboard-arrow-down-outline
                                                                                    </v-icon>
                                                                                    </v-btn>
                                                                                </template>
                                                                                <span>{{$t('zz_copy-to-next-line')}}</span>
                                                                            </v-tooltip>

                                                                            <span class="capitalised">{{$t('zz_thursday')}}</span>
                                                                        </div>
                                                                    </v-col>
                                                                    <v-col class="biz-hours-container" >

                                                                        <div class="biz-hours-row">
                                                                            <v-autocomplete
                                                                            :label="$t('zz_open_am')"
                                                                            v-model="storeBusiness.thursdayopening"
                                                                            name="thursdayopening"
                                                                            item-text="name"
                                                                            item-value="value"
                                                                            :items="times"
                                                                            :disabled="alwaysopen"
                                                                            ></v-autocomplete>
                                                                        </div>
                                                                        <div class="biz-hours-row">
                                                                            <v-autocomplete
                                                                            :label="$t('zz_close_am')"
                                                                            v-model="storeBusiness.thursdayclosing"
                                                                            name="thursdayclosing"
                                                                            item-text="name"
                                                                            item-value="value"
                                                                            :items="times"
                                                                            :disabled="alwaysopen"
                                                                            ></v-autocomplete>
                                                                        </div>

                                                                        <div class="biz-hours-row">
                                                                            <v-autocomplete
                                                                            :label="$t('zz_open_pm')"
                                                                            v-model="storeBusiness.thursdayopening2"
                                                                            name="thursdayopening2"
                                                                            item-text="name"
                                                                            item-value="value"
                                                                            :items="times"
                                                                            :disabled="alwaysopen"
                                                                            ></v-autocomplete>
                                                                        </div>
                                                                        <div class="biz-hours-row">
                                                                            <v-autocomplete
                                                                            :label="$t('zz_close_pm')"
                                                                            v-model="storeBusiness.thursdayclosing2"
                                                                            name="thursdayclosing2"
                                                                            item-text="name"
                                                                            item-value="value"
                                                                            :items="times"
                                                                            :disabled="alwaysopen"
                                                                            ></v-autocomplete>
                                                                        </div>

                                                                    </v-col>
                                                                </v-row>
                                                            </v-container>
                                                            <v-divider></v-divider>

        <!-- Friday     -->
                                                            <v-container class="ma-0 pa-0 biz-hours-container">
                                                                <v-row>
                                                                    <v-col class="ma-0 pa-0 biz-hours-container">
                                                                        <div class="biz-hours-day">
                                                                            <v-tooltip bottom>
                                                                                <template v-slot:activator="{ on, attrs }">
                                                                                    <v-btn
                                                                                    small
                                                                                    class="ma-1 px-1"
                                                                                    color="#FE5800"
                                                                                    @click="fridayTime"
                                                                                    v-bind="attrs"
                                                                                    v-on="on"
                                                                                    >
                                                                                    <v-icon
                                                                                    color="white"
                                                                                    >
                                                                                    mdi-clipboard-arrow-down-outline
                                                                                    </v-icon>
                                                                                    </v-btn>
                                                                                </template>
                                                                                <span>{{$t('zz_copy-to-next-line')}}</span>
                                                                            </v-tooltip>

                                                                            <span class="capitalised">{{$t('zz_friday')}}</span>
                                                                        </div>
                                                                    </v-col>
                                                                    <v-col class="biz-hours-container" >

                                                                        <div class="biz-hours-row">
                                                                            <v-autocomplete
                                                                            :label="$t('zz_open_am')"
                                                                            v-model="storeBusiness.fridayopening"
                                                                            name="fridayopening"
                                                                            item-text="name"
                                                                            item-value="value"
                                                                            :items="times"
                                                                            :disabled="alwaysopen"
                                                                            ></v-autocomplete>
                                                                        </div>
                                                                        <div class="biz-hours-row">
                                                                            <v-autocomplete
                                                                            :label="$t('zz_close_am')"
                                                                            v-model="storeBusiness.fridayclosing"
                                                                            name="fridayclosing"
                                                                            item-text="name"
                                                                            item-value="value"
                                                                            :items="times"
                                                                            :disabled="alwaysopen"
                                                                            ></v-autocomplete>
                                                                        </div>

                                                                        <div class="biz-hours-row">
                                                                            <v-autocomplete
                                                                            :label="$t('zz_open_pm')"
                                                                            v-model="storeBusiness.fridayopening2"
                                                                            name="fridayopening2"
                                                                            item-text="name"
                                                                            item-value="value"
                                                                            :items="times"
                                                                            :disabled="alwaysopen"
                                                                            ></v-autocomplete>
                                                                        </div>
                                                                        <div class="biz-hours-row">
                                                                            <v-autocomplete
                                                                            :label="$t('zz_close_pm')"
                                                                            v-model="storeBusiness.fridayclosing2"
                                                                            name="fridayclosing2"
                                                                            item-text="name"
                                                                            item-value="value"
                                                                            :items="times"
                                                                            :disabled="alwaysopen"
                                                                            ></v-autocomplete>
                                                                        </div>

                                                                    </v-col>
                                                                </v-row>
                                                            </v-container>
                                                            <v-divider></v-divider>

        <!-- Saturday     -->
                                                            <v-container class="ma-0 pa-0 biz-hours-container">
                                                                <v-row>
                                                                    <v-col class="ma-0 pa-0 biz-hours-container">
                                                                        <div class="biz-hours-day">
                                                                            <v-tooltip bottom>
                                                                                <template v-slot:activator="{ on, attrs }">
                                                                                    <v-btn
                                                                                    small
                                                                                    class="ma-1 px-1"
                                                                                    color="#FE5800"
                                                                                    @click="saturdayTime"
                                                                                    v-bind="attrs"
                                                                                    v-on="on"
                                                                                    >
                                                                                    <v-icon
                                                                                    color="white"
                                                                                    >
                                                                                    mdi-clipboard-arrow-down-outline
                                                                                    </v-icon>
                                                                                    </v-btn>
                                                                                </template>
                                                                                <span>{{$t('zz_copy-to-next-line')}}</span>
                                                                            </v-tooltip>

                                                                            <span class="capitalised">{{$t('zz_saturday')}}</span>
                                                                        </div>
                                                                    </v-col>
                                                                    <v-col class="biz-hours-container" >

                                                                        <div class="biz-hours-row">
                                                                            <v-autocomplete
                                                                            :label="$t('zz_open_am')"
                                                                            v-model="storeBusiness.saturdayopening"
                                                                            name="saturdayopening"
                                                                            item-text="name"
                                                                            item-value="value"
                                                                            :items="times"
                                                                            :disabled="alwaysopen"
                                                                            ></v-autocomplete>
                                                                        </div>
                                                                        <div class="biz-hours-row">
                                                                            <v-autocomplete
                                                                            :label="$t('zz_close_am')"
                                                                            v-model="storeBusiness.saturdayclosing"
                                                                            name="saturdayclosing"
                                                                            item-text="name"
                                                                            item-value="value"
                                                                            :items="times"
                                                                            :disabled="alwaysopen"
                                                                            ></v-autocomplete>
                                                                        </div>

                                                                        <div class="biz-hours-row">
                                                                            <v-autocomplete
                                                                            :label="$t('zz_open_pm')"
                                                                            v-model="storeBusiness.saturdayopening2"
                                                                            name="saturdayopening2"
                                                                            item-text="name"
                                                                            item-value="value"
                                                                            :items="times"
                                                                            :disabled="alwaysopen"
                                                                            ></v-autocomplete>
                                                                        </div>
                                                                        <div class="biz-hours-row">
                                                                            <v-autocomplete
                                                                            :label="$t('zz_close_pm')"
                                                                            v-model="storeBusiness.saturdayclosing2"
                                                                            name="saturdayclosing2"
                                                                            item-text="name"
                                                                            item-value="value"
                                                                            :items="times"
                                                                            :disabled="alwaysopen"
                                                                            ></v-autocomplete>
                                                                        </div>

                                                                    </v-col>
                                                                </v-row>
                                                            </v-container>
                                                            <v-divider></v-divider>

        <!-- Sunday     -->
                                                            <v-container class="ma-0 pa-0 biz-hours-container">
                                                                <v-row>
                                                                    <v-col class="ma-0 pa-0 biz-hours-container">
                                                                        <div class="biz-hours-day">
                                                                            <v-tooltip bottom>
                                                                                <template v-slot:activator="{ on, attrs }">
                                                                                    <v-btn
                                                                                    outlined
                                                                                    small
                                                                                    class="ma-1 px-1"
                                                                                    color="#FE5800"
                                                                                    @click="sundayTime"
                                                                                    v-bind="attrs"
                                                                                    v-on="on"
                                                                                    >
                                                                                    <v-icon
                                                                                    color="#FE5800"
                                                                                    >
                                                                                    mdi-clipboard-arrow-down-outline
                                                                                    </v-icon>
                                                                                    </v-btn>
                                                                                </template>
                                                                                <span>Take A Day Off! ;-)</span>
                                                                            </v-tooltip>

                                                                            <span class="capitalised">{{$t('zz_sunday')}}</span>
                                                                        </div>
                                                                    </v-col>
                                                                    <v-col class="biz-hours-container" >

                                                                        <div class="biz-hours-row">
                                                                            <v-autocomplete
                                                                            :label="$t('zz_open_am')"
                                                                            v-model="storeBusiness.sundayopening"
                                                                            name="sundayopening"
                                                                            item-text="name"
                                                                            item-value="value"
                                                                            :items="times"
                                                                            :disabled="alwaysopen"
                                                                            ></v-autocomplete>
                                                                        </div>
                                                                        <div class="biz-hours-row">
                                                                            <v-autocomplete
                                                                            :label="$t('zz_close_am')"
                                                                            v-model="storeBusiness.sundayclosing"
                                                                            name="sundayclosing"
                                                                            item-text="name"
                                                                            item-value="value"
                                                                            :items="times"
                                                                            :disabled="alwaysopen"
                                                                            ></v-autocomplete>
                                                                        </div>

                                                                        <div class="biz-hours-row">
                                                                            <v-autocomplete
                                                                            :label="$t('zz_open_pm')"
                                                                            v-model="storeBusiness.sundayopening2"
                                                                            name="sundayopening2"
                                                                            item-text="name"
                                                                            item-value="value"
                                                                            :items="times"
                                                                            :disabled="alwaysopen"
                                                                            ></v-autocomplete>
                                                                        </div>
                                                                        <div class="biz-hours-row">
                                                                            <v-autocomplete
                                                                            :label="$t('zz_close_pm')"
                                                                            v-model="storeBusiness.sundayclosing2"
                                                                            name="sundayclosing2"
                                                                            item-text="name"
                                                                            item-value="value"
                                                                            :items="times"
                                                                            :disabled="alwaysopen"
                                                                            ></v-autocomplete>
                                                                        </div>

                                                                    </v-col>
                                                                </v-row>
                                                            </v-container>
                                                            <v-divider></v-divider>

                                                            <v-container class="ma-0 pa-0 biz-hours-container">
                                                                <v-row>
                                                                    <v-col cols="12" md="12">
                                                                        <v-text-field
                                                                        v-model="storeBusiness.openinghoursother"
                                                                        type="text"
                                                                        name="openinghoursother"
                                                                        label="Opening Hours Other"

                                                                        ></v-text-field>
                                                                    </v-col>
                                                                </v-row>
                                                            </v-container>

                                                        </v-container>
                                                    </v-card>

                                                </v-card>

                                            </v-container>


<!-- ***BUSINESS ACTIVITIES   UI & TRANSLATIONS                                           -->
                                            <v-container class="container-card-1">



<!-- BUSINESS TYPE CUSTOMER TYPE CURRENCY                                                 -->
                                                <v-card elevation=12 class="max-300 card-1 ma-1 my-4 pa-0">
                                                    <v-row no-gutters class="card-header-1 pa-0 ma-0 px-3 pt-3">
                                                        <v-col cols="10" md="10" style="color:white" class="business-profile-section-heading pa-0 ma-0">
                                                            {{$t('zz_business_activity')}}<br>
                                                            <span style="color:white" class="english-label">P8 Business Activity</span>
                                                        </v-col>
                                                        <v-col cols="2" md="2">
                                                            <v-icon style="font-size:50px;color:white" class="pr-2">mdi-domain</v-icon>
                                                        </v-col>
                                                    </v-row>
<!-- Help Icon / dialog     -->
                                                        <template>
                                                            <div>
                                                                <v-expansion-panels>
                                                                    <v-expansion-panel>
                                                                        <v-expansion-panel-header>
                                                                            <v-icon color="#FE5800"
                                                                                style="flex:none">
                                                                            mdi-information-variant
                                                                            </v-icon>
                                                                        </v-expansion-panel-header>
                                                                        <v-expansion-panel-content class="info-dropdown">
                                                                            <div v-html="$t('zz_business_activities_explainer')">
                                                                            </div>
                                                                        </v-expansion-panel-content>
                                                                    </v-expansion-panel>
                                                                </v-expansion-panels>
                                                            </div>
                                                        </template>
                                                    <v-row class="pa-0 ma-0 px-3">
                                                        <v-col cols="12" md="12" class="px-3">
                                                            <v-autocomplete
                                                            dense
                                                            label="Business Type"
                                                            autocomplete="off"
                                                            v-model="storeBusiness.businessType"
                                                            name="businessType"
                                                            item-text="name"
                                                            item-value="value"
                                                            :items="types"
                                                            v-validate="'required'"
                                                            :error-messages="errors.collect('businessType')"
                                                            data-vv-name="businessType">
                                                            </v-autocomplete>
                                                        </v-col>

                                                        <v-col cols="12" md="12">
                                                            <v-autocomplete
                                                            dense
                                                            label="Customer Type"
                                                            autocomplete="off"
                                                            v-model="businessactivity_id"
                                                            name="businessactivity_id"
                                                            item-text="name"
                                                            item-value="id"
                                                            :items="businessactivities"
                                                            ></v-autocomplete>
                                                        </v-col>
                                                        <v-col cols="12" md="12">
                                                            <v-autocomplete
                                                            label="Currency"
                                                            v-model="currency_id"
                                                            name="currency_id"
                                                            item-text="name"
                                                            item-value="id"
                                                            :items="currencies">
                                                            <template v-slot:selection="data">
                                                                <v-icon v-text="data.item.icon" class="mr-3"></v-icon>{{data.item.name}}
                                                            </template>
                                                            <template v-slot:item="data">
                                                                <v-icon v-text="data.item.icon" class="mr-3"></v-icon>{{data.item.name}}
                                                            </template>
                                                            </v-autocomplete>
                                                        </v-col>
                                                    </v-row>
                                                    <v-col cols="12" md="12" class="pa-0 ma-0 px-3">
                                                        <v-row align="center">
                                                            <v-col cols="9" md="9" class="font-weight-bold" style="font-size:18px;" >
                                                                {{$t('zz_prices_include_tax')}}
                                                            </v-col>
                                                            <v-col cols="3" md="3">
                                                                <v-switch label="" v-model="taxpayable" color="success"></v-switch>
                                                            </v-col>
                                                        </v-row>
                                                    </v-col>
                                                </v-card>

<!-- AFORO CAPACITY -->
                                            <v-card elevation=12 class="max-300 card-1 ma-1 my-4 pa-0">
                                                    <v-row no-gutters class="card-header-1 pa-0 ma-0 px-3 pt-3">
                                                    <v-col cols="10" md="10" style="color:white" class="business-profile-section-heading pa-0 ma-0">
                                                        {{$t('zz_capactiy_aforo')}}<br>
                                                        <span style="color:white" class="english-label">P9 Capacity</span>
                                                    </v-col>
                                                    <v-col cols="2" md="2">
                                                        <v-icon style="font-size:50px;color:white" class="pr-2">mdi-account-multiple-plus</v-icon>
                                                    </v-col>
                                                </v-row>
<!-- Help Icon / dialog     -->
                                                <template>
                                                    <div>
                                                        <v-expansion-panels>
                                                            <v-expansion-panel>
                                                                <v-expansion-panel-header>
                                                                    <v-icon color="#FE5800"
                                                                        style="flex:none">
                                                                    mdi-information-variant
                                                                    </v-icon>
                                                                </v-expansion-panel-header>
                                                                <v-expansion-panel-content class="info-dropdown">
                                                                    <div v-html="$t('zz_capacity_explainer')">
                                                                    </div>
                                                                </v-expansion-panel-content>
                                                            </v-expansion-panel>
                                                        </v-expansion-panels>
                                                    </div>
                                                </template>
                                                <v-row class="ma-0 pa-0 px-3">
                                                    <v-col cols="6" md="6">
                                                        <v-text-field
                                                        v-model="storeBusiness.internalcapacity"
                                                        label="Internal"
                                                        name="internalcapacity"
                                                        type="number"
                                                        dense
                                                        ></v-text-field>
                                                    </v-col>
                                                    <v-col cols="6" md="6">
                                                        <v-text-field
                                                        v-model="storeBusiness.externalcapacity"
                                                        label="External"
                                                        name="externalcapacity"
                                                        type="number"
                                                        dense
                                                        ></v-text-field>
                                                    </v-col>
                                                </v-row>
                                            </v-card>

<!-- LIST OR GRID VIEW  -->
                                                <v-card elevation=12 class="max-300 card-1 ma-1 my-4 pa-0">
                                                    <v-row no-gutters class="card-header-1 pa-0 ma-0 px-3 pt-3">
                                                        <v-col cols="10" md="10" style="color:white" class="business-profile-section-heading pa-0 ma-0">
                                                            UI Settings<br>
                                                            <span style="color:white" class="english-label">P10 Grid Or List View</span>
                                                        </v-col>
                                                        <v-col cols="2" md="2">
                                                            <v-icon style="font-size:50px;color:white" class="pr-2">mdi-monitor-cellphone-star</v-icon>
                                                        </v-col>
                                                    </v-row>
<!-- Help Icon / dialog     -->
                                                    <template>
                                                        <div>
                                                            <v-expansion-panels>
                                                                <v-expansion-panel>
                                                                    <v-expansion-panel-header>
                                                                        <v-icon color="#FE5800"
                                                                            style="flex:none">
                                                                        mdi-information-variant
                                                                        </v-icon>
                                                                    </v-expansion-panel-header>
                                                                    <v-expansion-panel-content class="info-dropdown">
                                                                        <div v-html="$t('zz_ui_explainer')">
                                                                        </div>
                                                                    </v-expansion-panel-content>
                                                                </v-expansion-panel>
                                                            </v-expansion-panels>
                                                        </div>
                                                    </template>
                                                    <v-row class="pa-0 ma-0 px-3">
                                                        <v-col cols="12" md="12" class="px-3">

                                                            <v-autocomplete
                                                            v-model="viewtype"
                                                            name="viewtype"
                                                            item-text="name"
                                                            item-value="value"
                                                            :items="viewtypelist"
                                                            label="View Type"
                                                            dense
                                                            ></v-autocomplete>
                                                        </v-col>
                                                    </v-row>

                                                </v-card>

<!-- TRANSLATIONS SETTINGS -->
                                                <v-card elevation=12 class="max-300 card-1 ma-1 my-4 pa-0">
                                                    <v-row no-gutters class="card-header-1 pa-0 ma-0 px-3 pt-3">
                                                        <v-col cols="10" md="10" style="color:white" class="business-profile-section-heading pa-0 ma-0">
                                                            {{$t('zz_translations')}}<br>
                                                            <span style="color:white" class="english-label">P11 Translations</span>
                                                        </v-col>
                                                        <v-col cols="2" md="2">
                                                            <v-icon style="font-size:50px;color:white" class="pr-2">mdi-translate</v-icon>
                                                        </v-col>
                                                    </v-row>
<!-- Help Icon / dialog     -->
                                                    <template>
                                                        <div>
                                                            <v-expansion-panels>
                                                                <v-expansion-panel>
                                                                    <v-expansion-panel-header>
                                                                        <v-icon color="#FE5800"
                                                                            style="flex:none">
                                                                        mdi-information-variant
                                                                        </v-icon>
                                                                    </v-expansion-panel-header>
                                                                    <v-expansion-panel-content class="info-dropdown">
                                                                        <div v-html="$t('zz_translations_explainer')">
                                                                        </div>
                                                                    </v-expansion-panel-content>
                                                                </v-expansion-panel>
                                                            </v-expansion-panels>
                                                        </div>
                                                    </template>
                                                    <v-row class="pa-0 ma-0 px-3">
                                                        <v-col cols="12" md="12" class="px-5">
                                                           <!-- :label="$t('zz_translation_laguages')" -->

                                                            <v-autocomplete

                                                                v-model="translationlanguages"
                                                                name="translationlanguages"
                                                                item-text="name"
                                                                item-value="languagecode"
                                                                :items="lang2"
                                                                multiple
                                                                small-chips
                                                            >

                                                                <template v-slot:selection="{ item, index }">



                                                                    <v-chip style="width:100%;justify-content: flex-start;" outlined color="#FE5800" v-if="checklangactive(item.languagecode)" class="pa-1 pr-3">
                                                                        <v-switch class="pt-3" color="success" :input-value="shw"  @click.stop="updatelanguageactive(item.languagecode,0)" ></v-switch>
                                                                        <span class="py-5">{{ item.name }}</span>
                                                                    </v-chip>
                                                                    <v-chip style="width:100%;justify-content: flex-start;" outlined color="#FE5800" class="pa-1 pr-3" v-else>
                                                                        <v-switch class="pt-3" color="success" :input-value="nshw"  @click.stop="updatelanguageactive(item.languagecode,1)" ></v-switch>
                                                                            <span class="py-5">{{ item.name }}</span>
                                                                    </v-chip>
                                                                </template>
                                                            </v-autocomplete>

                                                        </v-col>
                                                    </v-row>

                                                </v-card>

<!-- SPLASHSCREEN IMAGE -->
                                                <v-card elevation=12 class="max-300 card-1 ma-0 pa-0">
                                                    <v-row no-gutters class="card-header-1 pa-0 ma-0 px-3 pt-3">
                                                        <v-col cols="10" md="10" style="color:white" class="business-profile-section-heading pa-0 ma-0">
                                                            {{$t('zz_splash_screen_image')}}<br>
                                                            <span style="color:white" class="english-label">P12 Splashscreen Image</span>
                                                        </v-col>
                                                        <v-col cols="2" md="2">
                                                            <v-icon style="font-size:50px;color:white" class="pr-2">mdi-image-outline</v-icon>
                                                        </v-col>
                                                    </v-row>
<!-- Help Icon / dialog     -->
                                                <template>
                                                    <div>
                                                        <v-expansion-panels>
                                                            <v-expansion-panel>
                                                                <v-expansion-panel-header>
                                                                    <v-icon color="#FE5800"
                                                                        style="flex:none">
                                                                    mdi-information-variant
                                                                    </v-icon>
                                                                </v-expansion-panel-header>
                                                                <v-expansion-panel-content class="info-dropdown">
                                                                    <div v-html="$t('zz_splashscreen_explainer')">
                                                                    </div>
                                                                </v-expansion-panel-content>
                                                            </v-expansion-panel>
                                                        </v-expansion-panels>
                                                    </div>
                                                </template>
                                                    <div class="pa-auto ma-0 true-center" style="height:150px">
                                                    <v-row>
                                                        <v-col cols="12" md="12" Class="pa-3 ma-0">
                                                            {{$t('zz_coming_soon')}}
                                                        </v-col>
                                                    </v-row>
                                                    </div>
                                                    <!-- <v-row no-gutters>
                                                        <v-col col="12" md="12" sm="12" class="text-center pa-3" v-if="overimage">
                                                            <span class="true-center">
                                                                <img style="max-width:100%"  :src="overimage" gradient="to right bottom, rgba(25, 25, 25, 0.125), rgba(25, 2, 22, 0.25)" class="grey lighten-2"  max-height="300"  v-if="overimage!=null" />
                                                            <v-icon v-if="overimage" style="position:absloute; justify-content:flex-end; top:70px; right:12px" color="red" icon dark  class="close" @click="delelteCoverImage()">mdi-close-circle</v-icon>
                                                            <v-btn width="25px" class="edit-food-photo-icon" style="position:absolute; top:47%; left:47%; color:#fff" icon @click="$refs.overfile.click()">
                                                                <v-icon style="font-size:50px; color:red">mdi-image-edit-outline</v-icon>
                                                            </v-btn>
                                                            </span>
                                                        </v-col>
                                                        <v-col cols="12" md="12" sm="12">
                                                            <v-row v-if="coverimguploading">
                                                                <v-col cols="12" class="text-center">
                                                                <v-progress-circular
                                                                    indeterminate
                                                                    color="primary"
                                                                    ></v-progress-circular>
                                                                </v-col>
                                                            </v-row>
                                                            <Cropper v-show="overviewimage!=null && overviewimage!='null' " classname="cropper pt-3" :src="overviewimage"
                                                            @change="onChangeOverView
                                                            ($event)" :stencilProps="{aspectRatio: 9/16}"/>

                                                            <v-btn v-show="overviewimage!=null && overviewimage!='null' "
                                                                :loading="loading3"
                                                                :disabled="loading3"
                                                                color="#FE5800"
                                                                class="ma-2 white--text"
                                                                @click="update"
                                                                >
                                                                SAVE
                                                                <v-icon
                                                                    right
                                                                    dark
                                                                >
                                                                    mdi-cloud-upload
                                                                </v-icon>
                                                            </v-btn>
                                                            <v-row>
                                                                <v-col cols="12" md="12" sm="12" align="center">
                                                                    <v-img v-if="!overimage"
                                                                        lazy-src="https://cdn.vuetifyjs.com/images/parallax/material.jpg"
                                                                        width="400"
                                                                        src="https://cdn.vuetifyjs.com/images/parallax/material.jpg"
                                                                    >
                                                                    </v-img>
                                                                    <v-btn class="edit-food-photo-icon" style="position:absolute; top:47%; left:47%; color:#fff" icon @click="$refs.overfile.click()">
                                                                    <input type="file" ref="overfile" @change="overimg($event)" accept="image/*" class="d-none" id="overimage"/>
                                                                    <v-icon v-if="!overimage" style="font-size:50px; color:blue">mdi-image-plus</v-icon>
                                                                    </v-btn>
                                                                </v-col>
                                                            </v-row>
                                                        </v-col>
                                                    </v-row> -->
                                                </v-card>


                                            </v-container>

<!-- ***SERVICES, DELIVERY & PAYMENTS                                           -->
                                            <v-container class="container-card-1">

<!-- SERVICES PROVIDED -->
                                            <v-card elevation=12 class="max-300 card-1 ma-0 my-4 pa-0">
                                                <v-row no-gutters class="card-header-1 pa-0 ma-0 px-3 pt-3">
                                                    <v-col cols="10" md="10" style="color:white" class="business-profile-section-heading pa-0 ma-0">
                                                        {{$t('zz_f_b_services')}}<br>
                                                        <span style="color:white" class="english-label">P13 F&B Products & Services</span>
                                                    </v-col>
                                                    <v-col cols="2" md="2">
                                                        <v-icon style="font-size:50px;color:white" class="pr-2">mdi-basket</v-icon>
                                                    </v-col>
                                                </v-row>
<!-- Help Icon / dialog     -->
                                                <template>
                                                    <div>
                                                        <v-expansion-panels>
                                                            <v-expansion-panel>
                                                                <v-expansion-panel-header>
                                                                    <v-icon color="#FE5800"
                                                                        style="flex:none">
                                                                    mdi-information-variant
                                                                    </v-icon>
                                                                </v-expansion-panel-header>
                                                                <v-expansion-panel-content class="info-dropdown">
                                                                    <div v-html="$t('zz_products_services_explainer')">
                                                                    </div>
                                                                </v-expansion-panel-content>
                                                            </v-expansion-panel>
                                                        </v-expansion-panels>
                                                    </div>
                                                </template>
                                                <v-row align="center" class="ma-0 pa-0 px-3 mt-5">
                                                    <v-col cols="10" md="10" class="pt-0 pb-0">
                                                        Eat In
                                                    </v-col>
                                                    <v-col cols="2" md="2" class="pt-0 pb-0">
                                                        <v-checkbox
                                                        v-model="haseatin"
                                                        name="haseatin"
                                                        label=""
                                                        class="txt-color "
                                                        dense
                                                        ></v-checkbox>
                                                    </v-col>
                                                </v-row>
                                                <v-row align="center" class="ma-0 pa-0 px-3">
                                                    <v-col cols="10" md="10" class="pt-0 pb-0 px-3">
                                                        Take Away
                                                    </v-col>
                                                    <v-col cols="2" md="2" class="pt-0 pb-0">
                                                        <v-checkbox
                                                        v-model="hastakeaway"
                                                        name="hastakeaway"
                                                        label=""
                                                        class="txt-color"
                                                        dense
                                                        ></v-checkbox>
                                                    </v-col>
                                                </v-row>
                                                <v-row align="center" class="ma-0 pa-0 px-3">
                                                    <v-col cols="10" md="10" class="pt-0 pb-0">
                                                        Delivery
                                                    </v-col>
                                                    <v-col cols="2" md="2" class="pt-0 pb-0">
                                                        <v-checkbox
                                                        v-model="hasdelivery"
                                                        name="hasdelivery"
                                                        label=""
                                                        class="txt-color"
                                                        dense
                                                        ></v-checkbox>
                                                    </v-col>
                                                </v-row>
                                            </v-card>


<!-- DELIVER OPTIONS -->
                                            <v-card elevation=12 class="max-300 card-1 ma-0 my-4 pa-0">
                                                <v-row no-gutters class="card-header-1 pa-0 ma-0 px-3 pt-3">
                                                    <v-col cols="10" md="10"  style="color:white" class="pa-0 ma-0">
                                                        {{$t('zz_delivery_service')}}<br>
                                                        <span style="color:white" class="english-label">P15 Delivery Service</span>
                                                    </v-col>
                                                    <v-col cols="2" md="2">
                                                        <v-icon style="font-size:50px;color:white" class="pr-2">mdi-moped</v-icon>
                                                    </v-col>
                                                </v-row>
<!-- Help Icon / dialog     -->
                                                <template>
                                                    <div>
                                                        <v-expansion-panels>
                                                        <v-expansion-panel>
                                                            <v-expansion-panel-header>
                                                            <v-icon color="#FE5800"
                                                                    style="flex:none">
                                                                mdi-information-variant
                                                                </v-icon>
                                                            </v-expansion-panel-header>
                                                            <v-expansion-panel-content class="info-dropdown">
                                                            <div v-html="$t('zz_delivery_explainer')">
                                                            </div>
                                                            </v-expansion-panel-content>
                                                        </v-expansion-panel>
                                                        </v-expansion-panels>
                                                    </div>
                                                </template>
                                                <v-col cols="12" md="12" class="pa-0 ma-0 px-3 py-5">
                                                    <p class="mx-3">{{$t('zz_free_delivery_text')}}</p>
                                                    <v-text-field
                                                    v-model="storeBusiness.deliveryfreeorder"
                                                    name="deliveryfreeorder"
                                                    :label="$t('zz_free_delivery_on_orders_above')"
                                                    dense
                                                    outlined
                                                    ></v-text-field>
                                                </v-col>
                                                <v-col cols="12" md="12" class="pa-0 ma-0 px-3">
                                                    <p class="mx-3">{{$t('zz_delivery_notes_explainer')}}</p>
                                                    <v-textarea
                                                    v-model="storeBusiness.deliverynotes"
                                                    name="deliverynotes"
                                                    :label="$t('zz_delivery_notes')"
                                                    outlined
                                                    ></v-textarea>
                                                </v-col>
                                            </v-card>

<!-- WHATSAPP MESSAGE -->
                                            <v-card elevation=12 class="max-300 card-1 ma-0 pa-0">
                                                <v-row no-gutters class="whatsapp-card-header pa-0 ma-0 px-3 pt-3">
                                                    <v-col cols="10" md="10" style="color:white" class="business-profile-section-heading pa-0 ma-0">
                                                        {{$t('zz_whatsapp_message')}}<br>
                                                        <span style="color:white" class="english-label">P16 Whatsapp Message</span>
                                                    </v-col>
                                                    <v-col cols="2" md="2" class="pa-0 ma-0">
                                                        <v-icon style="font-size:40px;color:white">mdi-whatsapp</v-icon>
                                                    </v-col>
                                                </v-row>
<!-- Help Icon / dialog     -->
                                                <template>
                                                    <div>
                                                        <v-expansion-panels>
                                                            <v-expansion-panel>
                                                                <v-expansion-panel-header>
                                                                    <v-icon color="#FE5800"
                                                                        style="flex:none">
                                                                    mdi-information-variant
                                                                    </v-icon>
                                                                </v-expansion-panel-header>
                                                                <v-expansion-panel-content class="info-dropdown">
                                                                    <div v-html="$t('zz_whatsapp_explainer')">
                                                                    </div>
                                                                </v-expansion-panel-content>
                                                            </v-expansion-panel>
                                                        </v-expansion-panels>
                                                    </div>
                                                </template>
                                                <v-col cols="12" md="12" class="pt-3">
                                                        <v-text-field
                                                        v-model="storeBusiness.whatsapp"
                                                        :label="$t('zz_whatsapp')"
                                                        name="whatsapp"
                                                        type="tel"
                                                        dense
                                                        ></v-text-field>
                                                    </v-col>
                                                <!-- <v-row class="pa-o ma-0">
                                                    <v-col cols="12" md="12" Class="pa-3 ma-0">
                                                        {{$t('zz_whatsapp_explainer')}}
                                                    </v-col>
                                                </v-row> -->
                                                <v-row class="ma-0 pa-1">
                                                    <v-col cols="12" md="12" sm="12">
                                                    <v-textarea
                                                        outlined
                                                        dense
                                                        v-model="storeBusiness.whatsapmsg"
                                                        name="whatsapmsg"
                                                        :label="$t('zz_whatsapp_message')"
                                                        >
                                                    </v-textarea>
                                                    </v-col>
                                                </v-row>
                                            </v-card>
<!-- BUSINESS PAYMENTS  -->
                                            <v-card elevation=12  class="max-300 card-1 ma-0 my-4 pa-0">
                                                <v-row no-gutters class="card-header-1 pa-0 ma-0 px-3 pt-3">
                                                    <v-col cols="10" md="10" style="color:white" class="business-profile-section-heading pa-0 ma-0">
                                                        {{$t('zz_payments_transactions')}}<br>
                                                        <span style="color:white" class="english-label">P14 Payments & Transactions</span>
                                                    </v-col>
                                                    <v-col cols="2" md="2">
                                                        <v-icon style="font-size:50px;color:white" class="pr-2">mdi-currency-eur</v-icon>
                                                    </v-col>
                                                </v-row>
<!-- Help Icon / dialog     -->
                                                <template>
                                                    <div>
                                                        <v-expansion-panels>
                                                        <v-expansion-panel>
                                                            <v-expansion-panel-header>
                                                            <v-icon color="#FE5800"
                                                                    style="flex:none">
                                                                mdi-information-variant
                                                                </v-icon>
                                                            </v-expansion-panel-header>
                                                            <v-expansion-panel-content class="info-dropdown">
                                                            <div v-html="$t('zz_stripe_explained')">
                                                            </div>
                                                            </v-expansion-panel-content>
                                                        </v-expansion-panel>
                                                        </v-expansion-panels>
                                                    </div>
                                                </template>

                                                <!-- <div  class="px-3 mt-5" v-html="$t('zz_stripe_signup')"></div> -->
                                                <v-row align="center" class="pa-0 ma-0">
                                                    <v-col cols="9" md="9" class="font-weight-bold pa-0 ma-0 px-3" style="font-size:18px;" >
                                                        <v-img :src="stripelogo" style="width:50px"></v-img>
                                                    </v-col>
                                                    <v-col cols="3" md="3" v-if="paymentenabled">
                                                        <v-switch label="" :input-value="payshw" v-model="paymentenabled" color="success"></v-switch>
                                                    </v-col>
                                                    <v-col cols="3" md="3" v-else>
                                                        <v-switch label="" :input-value="paynshw" v-model="paymentenabled" color="success"></v-switch>
                                                    </v-col>
                                                </v-row>
                                                <v-row v-show="paymentenabled" class="pa-3 ma-0 px-3">
                                                    <v-col cols="12" md="12">
                                                        <v-text-field
                                                        v-model="stripapikey"
                                                        label="Stripe Api Key"
                                                        name="stripapikey"
                                                        type="text"
                                                        dense

                                                        ></v-text-field>
                                                    </v-col>
                                                    <v-col cols="12" md="12">
                                                        <v-text-field
                                                        v-model="stripsecretkey"
                                                        label="Stripe Secret Key"
                                                        name="stripsecretkey"
                                                        type="text"
                                                        dense

                                                        ></v-text-field>
                                                    </v-col>
                                                </v-row>
                                                <!-- <v-row align="center" class="pa-0 ma-0">
                                                    <v-col cols="9" md="9" class="font-weight-bold pa-0 ma-0 px-3" style="font-size:18px;" >
                                                        Payment Enabled
                                                    </v-col>
                                                    <v-col cols="3" md="3">
                                                        <v-switch label="" v-model="data.paymentenabled" color="success"></v-switch>
                                                    </v-col>
                                                </v-row>
                                                <v-row v-show="data.paymentenabled" class="pa-3 ma-0 px-3">
                                                    <v-col cols="12" md="12">
                                                        <v-text-field
                                                        v-model="this.data.stripapikey"
                                                        label="Stripe Api Key"
                                                        name="stripapikey"
                                                        type="text"
                                                        dense

                                                        ></v-text-field>
                                                    </v-col>
                                                    <v-col cols="12" md="12">
                                                        <v-text-field
                                                        v-model="this.data.stripsecretkey"
                                                        label="Stripe Secret Key"
                                                        name="stripsecretkey"
                                                        type="text"
                                                        dense

                                                        ></v-text-field>
                                                    </v-col>
                                                </v-row> -->
                                            </v-card>

                                            </v-container>

<!-- ***COVER IMAGE, LOGO, THEME COLOR  -->
                                            <v-container class="container-card-1">




<!-- COVER IMAGE -->
                                                <v-card elevation=12 class="max-300 card-1 ma-0 pa-0">
                                                    <v-row no-gutters class="card-header-1 pa-0 ma-0 px-3 pt-3">
                                                        <v-col cols="10" md="10" style="color:white" class="business-profile-section-heading pa-0 ma-0">
                                                            {{$t('zz_cover_image')}}<br>
                                                            <span style="color:white" class="english-label">P17 Cover Image</span>
                                                        </v-col>
                                                        <v-col cols="2" md="2">
                                                            <v-icon style="font-size:50px;color:white" class="pr-2">mdi-image-outline</v-icon>
                                                        </v-col>
                                                    </v-row>
<!-- Help Icon / dialog     -->
                                                <template>
                                                    <div>
                                                        <v-expansion-panels>
                                                            <v-expansion-panel>
                                                                <v-expansion-panel-header>
                                                                    <v-icon color="#FE5800"
                                                                        style="flex:none">
                                                                    mdi-information-variant
                                                                    </v-icon>
                                                                </v-expansion-panel-header>
                                                                <v-expansion-panel-content class="info-dropdown">
                                                                    <div v-html="$t('zz_cover_image_explainer')">
                                                                    </div>
                                                                </v-expansion-panel-content>
                                                            </v-expansion-panel>
                                                        </v-expansion-panels>
                                                    </div>
                                                </template>
                                                    <v-row no-gutters>
                                                        <v-col col="12" md="12" sm="12" class="text-center pa-3" v-if="overimage">
                                                            <span class="true-center">
                                                                <img style="max-width:100%"  :src="overimage" gradient="to right bottom, rgba(25, 25, 25, 0.125), rgba(25, 2, 22, 0.25)" class="grey lighten-2"  max-height="300"  v-if="overimage!=null" />
                                                            <v-icon v-if="overimage" style="position:absloute; justify-content:flex-end; top:70px; right:12px" color="red" icon dark  class="close" @click="delelteCoverImage()">mdi-close-circle</v-icon>
                                                            <v-btn width="25px" class="edit-food-photo-icon" style="position:absolute; top:47%; left:47%; color:#fff" icon @click="$refs.overfile.click()">
                                                                <v-icon style="font-size:50px; color:pink">mdi-image-edit-outline</v-icon>
                                                            </v-btn>
                                                            </span>
                                                        </v-col>
                                                        <v-col cols="12" md="12" sm="12">
                                                            <v-row v-if="coverimguploading">
                                                                <v-col cols="12" class="text-center">
                                                                <v-progress-circular
                                                                    indeterminate
                                                                    color="primary"
                                                                    ></v-progress-circular>
                                                                </v-col>
                                                            </v-row>
                                                            <Cropper v-show="overviewimage!=null && overviewimage!='null' " classname="cropper pt-3" :src="overviewimage"
                                                            @change="onChangeOverView
                                                            ($event)" :stencilProps="{aspectRatio: 16/9}"/>

                                                            <v-btn v-show="overviewimage!=null && overviewimage!='null' "
                                                                :loading="loading3"
                                                                :disabled="loading3"
                                                                color="#FE5800"
                                                                class="ma-2 white--text"
                                                                @click="update"
                                                                >
                                                                SAVE
                                                                <v-icon
                                                                    right
                                                                    dark
                                                                >
                                                                    mdi-cloud-upload
                                                                </v-icon>
                                                            </v-btn>
                                                            <v-row>
                                                                <v-col cols="12" md="12" sm="12" align="center">
                                                                    <v-img v-if="!overimage"
                                                                        lazy-src="https://cdn.vuetifyjs.com/images/parallax/material.jpg"
                                                                        width="400"
                                                                        src="https://cdn.vuetifyjs.com/images/parallax/material.jpg"
                                                                    >
                                                                    </v-img>
                                                                    <v-btn class="edit-food-photo-icon" style="position:absolute; top:47%; left:47%; color:#fff" icon @click="$refs.overfile.click()">
                                                                    <input type="file" ref="overfile" @change="overimg($event)" accept="image/*" class="d-none" id="overimage"/>
                                                                    <v-icon v-if="!overimage" style="font-size:50px; color:pink">mdi-image-plus</v-icon>
                                                                    </v-btn>
                                                                </v-col>
                                                            </v-row>
                                                        </v-col>
                                                    </v-row>
                                                </v-card>



<!-- BUSINESS LOGO -->
                                                <v-card elevation=12 class="max-300 card-1 ma-0 pa-0">
                                                    <v-row no-gutters class="card-header-1 pa-0 ma-0 px-3 pt-3">
                                                        <v-col cols="10" md="10" style="color:white" class="business-profile-section-heading pa-0 ma-0">
                                                            LOGO<br>
                                                            <span style="color:white" class="english-label">P18 Business Logo</span>
                                                        </v-col>
                                                        <v-col cols="2" md="2">
                                                            <v-icon style="font-size:50px;color:white" class="pr-2">mdi-bookmark-outline</v-icon>
                                                        </v-col>
                                                    </v-row>
<!-- Help Icon / dialog     -->
                                                    <template>
                                                        <div>
                                                            <v-expansion-panels>
                                                                <v-expansion-panel>
                                                                    <v-expansion-panel-header>
                                                                        <v-icon color="#FE5800"
                                                                            style="flex:none">
                                                                        mdi-information-variant
                                                                        </v-icon>
                                                                    </v-expansion-panel-header>
                                                                    <v-expansion-panel-content class="info-dropdown">
                                                                        <div v-html="$t('zz_logo_explainer')">
                                                                        </div>
                                                                    </v-expansion-panel-content>
                                                                </v-expansion-panel>
                                                            </v-expansion-panels>
                                                        </div>
                                                    </template>
                                                    <v-row class="pa-0 ma-0">
                                                    <v-col col="12" md="12" sm="12" class="text-center lite-border" v-if="image">
                                                        <img style="max-width:100%"  :src="image"  class="grey lighten-2 pa-3 ma-3"  max-height="300"  v-if="image!=null" />
                                                        <v-icon v-if="overimage" style="position:absloute; justify-content:flex-end; top:70px; right:12px" color="red" icon dark  class="close" @click="delelteLogoImage()">mdi-close-circle</v-icon>
                                                        <!-- <v-icon class="close" @click="delelteLogoImage()">mdi-close-box-outline</v-icon> -->
                                                    </v-col>
                                                    <v-col cols="12" md="12" sm="12">
                                                        <v-row v-if="logoimageuploading">
                                                            <v-col cols="12" class="text-center">
                                                            <v-progress-circular
                                                                indeterminate
                                                                color="primary"
                                                                ></v-progress-circular>
                                                            </v-col>
                                                        </v-row>
                                                        <Cropper v-show="uploadedimage!=null && uploadedimage!='null' " classname="cropper" :src="uploadedimage" @change="onChange"/>

                                                            <v-btn v-show="overviewimage!=null && overviewimage!='null' "
                                                                :loading="loading3"
                                                                :disabled="loading3"
                                                                color="#FE5800"
                                                                class="ma-2 white--text"
                                                                @click="update"
                                                                >
                                                                SAVE
                                                                <v-icon
                                                                    right
                                                                    dark
                                                                >
                                                                    mdi-cloud-upload
                                                                </v-icon>
                                                            </v-btn>
                                                        <v-row>
                                                        <v-col cols="12" md="12" sm="12" align="center">
                                                            <v-btn color="primary" @click="$refs.file.click()">

                                                            <input type="file" ref="file" @change="uploadImage($event)" accept="image/*" class="d-none" id="logo"/> <span v-text="image!=null?'Change ':'Upload '" class="mr-1"></span> <span>Image</span>
                                                            </v-btn>
                                                        </v-col>
                                                        </v-row>
                                                    </v-col>
                                                    </v-row>
                                                </v-card>

<!-- THEME COLOR -->
                                                <v-card elevation=12 class="max-300 card-1 ma-0 pa-0">
                                                    <v-row no-gutters class="card-header-1 pa-0 ma-0 px-3 pt-3">
                                                        <v-col cols="10" md="10" style="color:white" class="business-profile-section-heading pa-0 ma-0">
                                                            {{$t('zz_theme_color')}}<br>
                                                            <span style="color:white" class="english-label">P19 Theme Colour</span>
                                                        </v-col>
                                                        <v-col cols="2" md="2">
                                                            <v-icon style="font-size:50px;color:white" class="pr-2">mdi-format-color-fill</v-icon>
                                                        </v-col>
                                                    </v-row>
<!-- Help Icon / dialog     -->
                                                    <template>
                                                        <div>
                                                            <v-expansion-panels>
                                                                <v-expansion-panel>
                                                                    <v-expansion-panel-header>
                                                                        <v-icon color="#FE5800"
                                                                            style="flex:none">
                                                                        mdi-information-variant
                                                                        </v-icon>
                                                                    </v-expansion-panel-header>
                                                                    <v-expansion-panel-content class="info-dropdown">
                                                                        <div v-html="$t('zz_theme_explainer')">
                                                                        </div>
                                                                    </v-expansion-panel-content>
                                                                </v-expansion-panel>
                                                            </v-expansion-panels>
                                                        </div>
                                                    </template>
                                                    <v-color-picker class="mb-5 pb-5 " v-model="themecolor" show-swatches flat ></v-color-picker>
                                                </v-card>

                                            </v-container>


<!-- ***SOCIAL NETWORKS -->
                                            <v-container class="container-card-1">


<!-- SOCIAL MEDIA -->
                                                <v-card elevation=12 class="card-1 ma-5 pa-0">
                                                    <v-row no-gutters class="social-networks-card-header pa-0 ma-0 px-3 pt-3">
                                                        <v-col cols="10" md="10" style="color:white" class="business-profile-section-heading pa-0 ma-0">
                                                            {{$t('zz_social_media')}}<br>
                                                            <span style="color:white" class="english-label">P20 Social Networks</span>
                                                        </v-col>
                                                        <v-col cols="2" md="2">
                                                            <v-icon style="font-size:50px;color:white" class="pr-2">mdi-arrow-decision</v-icon>
                                                        </v-col>
                                                    </v-row>
<!-- Help Icon / dialog     -->
                                                <template>
                                                    <div>
                                                        <v-expansion-panels>
                                                            <v-expansion-panel>
                                                                <v-expansion-panel-header>
                                                                    <v-icon color="#FE5800"
                                                                        style="flex:none">
                                                                    mdi-information-variant
                                                                    </v-icon>
                                                                </v-expansion-panel-header>
                                                                <v-expansion-panel-content class="info-dropdown">
                                                                    <div v-html="$t('zz_socialnetworks_explainer')">
                                                                    </div>
                                                                </v-expansion-panel-content>
                                                            </v-expansion-panel>
                                                        </v-expansion-panels>
                                                    </div>
                                                </template>
                                                    <v-containter class="container-card-3">
                                                    <v-row  v-for="(item, index) in socialmedia" :key="index">
                                                        <v-card elevation=12 class="max-300 card-1 ma-5 pa-0">
                                                        <v-row no-gutters class="pa-0 ma-0 px-3 pt-3">
                                                            <v-col cols="12" md="12" >
                                                                <v-select
                                                                label="Social Network"
                                                                v-model="item.id"
                                                                :name="'socialmedia_id['+index+']'"
                                                                item-text="name"
                                                                item-value="id"
                                                                :items="socialmedias">
                                                                <template v-slot:selection="data">
                                                                    <v-icon v-text="data.item.icon" class="mr-3"></v-icon>{{data.item.name}}
                                                                </template>
                                                                <template v-slot:item="data">
                                                                    <v-icon v-text="data.item.icon" class="mr-3"></v-icon>{{data.item.name}}
                                                                </template>
                                                                </v-select>
                                                            </v-col>
                                                            <v-col cols="12" md="12" sm="12">
                                                                <v-text-field
                                                                    v-model="item.value"
                                                                    :name="'value['+index+']'"
                                                                    label="Link"
                                                                    >

                                                                </v-text-field>
                                                            </v-col>
                                                            <v-col cols="12" md="12" sm="1" justify="right" align="right">
                                                                <v-row class="">
                                                                    <v-col cols="12" md="12" sm="12">

                                                                        <a @click="socialmedia.splice(index, 1)"><v-icon  style="color:red">mdi-delete</v-icon></a>
                                                                    </v-col>
                                                                </v-row>

                                                            </v-col>

                                                        </v-row>
                                                        </v-card>
                                                    </v-row>
                                                    </v-containter>
                                                        <v-row class="pa-3">
                                                            <v-col cols="12" md="12" sm="12" class="text-left">
                                                                <span @click="add" style="color:#FE5800" class="">{{$t('zz_add_new')}}<v-icon class="pr-1 addnewicon">mdi-plus-circle-outline</v-icon></span>
                                                                <!-- <v-btn class="add " color="primary" @click="add">Add Social Media</v-btn> -->
                                                            </v-col>
                                                        </v-row>

                                                </v-card>

                                            </v-container>

<!-- ***ABOUT THE BUSINESS -->
                                            <v-container class="container-card-1">

                                                <v-card elevation=12 class="card-1 ma-05 pa-0">
                                                    <v-row no-gutters class="card-header-1 pa-0 ma-0 px-3 pt-3">
                                                        <v-col cols="10" md="10" style="color:white" class="business-profile-section-heading pa-0 ma-0">
                                                            {{$t('zz_about_your_business')}}<br>
                                                            <span style="color:white" class="english-label">P21 About Your Business</span>
                                                        </v-col>
                                                        <v-col cols="2" md="2">
                                                            <v-icon style="font-size:50px;color:white" class="pr-2">mdi-book-information-variant</v-icon>
                                                        </v-col>
                                                    </v-row>
<!-- Help Icon / dialog     -->
                                                    <template>
                                                        <div>
                                                            <v-expansion-panels>
                                                                <v-expansion-panel>
                                                                    <v-expansion-panel-header>
                                                                        <v-icon color="#FE5800"
                                                                            style="flex:none">
                                                                        mdi-information-variant
                                                                        </v-icon>
                                                                    </v-expansion-panel-header>
                                                                    <v-expansion-panel-content class="info-dropdown">
                                                                        <div v-html="$t('zz_about_your_business_explainer')">
                                                                        </div>
                                                                    </v-expansion-panel-content>
                                                                </v-expansion-panel>
                                                            </v-expansion-panels>
                                                        </div>
                                                    </template>
<!-- DEFAULT DESCRIPTION                                                     -->

                                                    <v-card elevation=12 class="card-1 ma-5 pa-5 text-center">
                                                        <v-row no-gutters class="pa-0 ma-0 px-3 pt-3">
                                                                            <!-- <v-row no-gutters  style="align-items:center"> -->
                                                            <v-col cols="12" md="12" class="text-left">
                                                            <img :src="lphoto" height="20px">
                                                            <span class="lang-short-code"> - {{lcode}}</span>
                                                            </v-col>
                                                        </v-row>
                                                        <v-row no-gutters class="pa-0 ma-0 px-3 pt-3">
                                                            <v-col cols="12" md="12" sm="12">
                                                                <editor
                                                                api-key="kmqk9zj3cswmwgz5j95fcwx8fh4nutj31o7ru7va5lxht7nk"
                                                                initialValue=""
                                                                v-model="description"
                                                                :init="editorConfigDescription"
                                                                ></editor>
                                                            </v-col>
                                                        </v-row>
                                                    </v-card>
<!-- TRANSLATIONS DESCRIPTIONS                         -->
                                                    <v-containter class="container-card-1">
                                                        <v-row v-for="(translang, index) in translationlanguages" :key="'translang-'+index">
                                                            <!-- <v-card elevation=12 class="max-300 card-1 ma-5 pa-0">
                                                                <v-row no-gutters class="pa-0 ma-0 px-3 pt-3"> -->
                                                                    <v-card elevation=12 class="card-1 ma-5 pa-0">
                                                                        <v-row no-gutters class="pa-0 ma-0 px-3 pt-3">
                                                                            <!-- <v-row no-gutters  style="align-items:center"> -->
                                                                            <v-col cols="12" md="12">
                                                                            <img :src="'https://api.juzzap.com/storage/flags/'+translang+'.svg'" height="20px">
                                                                            <span class="lang-short-code"> - {{translang}}</span>
                                                                            </v-col>
                                                                        </v-row>
                                                                        <editor
                                                                        api-key="kmqk9zj3cswmwgz5j95fcwx8fh4nutj31o7ru7va5lxht7nk"
                                                                        initialValue=""
                                                                        v-model="languagetranslations[translang]"
                                                                        :init="editorConfigDescription"
                                                                        ></editor>
                                                                    </v-card>
                                                                <!-- </v-row>
                                                            </v-card> -->
                                                        </v-row>
                                                    </v-containter>
                                                </v-card>

                                            </v-container>

<!-- BUSINESS FACILITIES -->
                                            <v-container class="container-card-1">
                                                <v-card elevation=12 class="card-1 ma-05 pa-0">
                                                    <v-row no-gutters class="card-header-1 pa-0 ma-0 px-3 pt-3">
                                                        <v-col cols="10" md="10" style="color:white" class="business-profile-section-heading pa-0 ma-0">
                                                            {{$t('zz_facilities')}}<br>
                                                            <span style="color:white" class="english-label">P22 Business Facilities</span>
                                                        </v-col>
                                                        <v-col cols="2" md="2">
                                                            <v-icon style="font-size:50px;color:white" class="pr-2">mdi-book-open-page-variant</v-icon>
                                                        </v-col>
                                                    </v-row>
<!-- Help Icon / dialog     -->
                                                <template>
                                                    <div>
                                                        <v-expansion-panels>
                                                            <v-expansion-panel>
                                                                <v-expansion-panel-header>
                                                                    <v-icon color="#FE5800"
                                                                        style="flex:none">
                                                                    mdi-information-variant
                                                                    </v-icon>
                                                                </v-expansion-panel-header>
                                                                <v-expansion-panel-content class="info-dropdown">
                                                                    <div v-html="$t('zz_facilities_explainer')">
                                                                    </div>
                                                                </v-expansion-panel-content>
                                                            </v-expansion-panel>
                                                        </v-expansion-panels>
                                                    </div>
                                                </template>
                                                    <v-containter class="container-card-2">
                                                        <v-row v-for="(item, index) in facilities" :key="index">
                                                            <v-card elevation=12 class="max-300 card-1 ma-5 pa-0">
                                                                <v-row no-gutters class="pa-0 ma-0 px-3 pt-3">
                                                                    <v-col cols="12" md="12" >
                                                                        <v-autocomplete
                                                                        label="Facility Icon"
                                                                        v-model="item.id"
                                                                        :name="'facilities_id['+index+']'"
                                                                        item-text="name"
                                                                        item-value="id"
                                                                        :items="facilitiy">
                                                                        <template v-slot:selection="data">
                                                                            <v-icon v-text="data.item.icon" class="mr-3"></v-icon>{{data.item.name}}
                                                                        </template>
                                                                        <template v-slot:item="data">
                                                                            <v-icon v-text="data.item.icon" class="mr-3"></v-icon>{{data.item.name}}
                                                                        </template>
                                                                        </v-autocomplete>
                                                                    </v-col>
                                                                    <v-col cols="12" md="12" sm="12">
                                                                        <v-text-field
                                                                            v-model="item.link"
                                                                            :name="'link['+index+']'"
                                                                            label="Link"
                                                                            >
                                                                        </v-text-field>
                                                                    </v-col>
                                                                    <v-col cols="12" md="12" sm="12">
                                                                        <v-text-field
                                                                            v-model="item.description"
                                                                            :name="'description['+index+']'"
                                                                            label="Description"
                                                                            >
                                                                        </v-text-field>
                                                                    </v-col>
                                                                    <v-col cols="12" md="12" sm="12" justify="right" align="right">
                                                                        <v-row class="">
                                                                            <v-col cols="12" md="12" sm="12">
                                                                                <a @click="facilities.splice(index, 1)"><v-icon  style="color:red">mdi-close-circle</v-icon></a>
                                                                            </v-col>
                                                                        </v-row>
                                                                    </v-col>
                                                                </v-row>
                                                            </v-card>
                                                        </v-row>
                                                    </v-containter>
                                                    <v-row class="pa-3">
                                                        <v-col cols="12" md="12" sm="12" class="text-left">
                                                            <span @click="addFacility" style="color:#FE5800" class="">{{$t('zz_add_new')}}<v-icon class="pr-1 addnewicon">mdi-plus-circle-outline</v-icon></span>
                                                            <!-- <v-btn class="add " color="primary" @click="addFacility">Add Facility</v-btn> -->
                                                        </v-col>
                                                    </v-row>
                                                </v-card>
                                            </v-container>



<!-- GALLERY -->
                                            <v-card elevation=12 class="card-1 ma-05 pa-0">
                                                <v-row no-gutters class="card-header-1 pa-0 ma-0 px-3 pt-3">
                                                    <v-col cols="10" md="10" style="color:white" class="business-profile-section-heading pa-0 ma-0">
                                                        {{$t('zz_photo_gallery')}}<br>
                                                        <span style="color:white" class="english-label">P23 Photo Gallery</span>
                                                    </v-col>
                                                    <v-col cols="2" md="2">
                                                        <v-icon style="font-size:50px;color:white" class="pr-2">mdi-image-multiple</v-icon>
                                                    </v-col>
                                                </v-row>
<!-- Help Icon / dialog     -->
                                                <template>
                                                    <div>
                                                        <v-expansion-panels>
                                                            <v-expansion-panel>
                                                                <v-expansion-panel-header>
                                                                    <v-icon color="#FE5800"
                                                                        style="flex:none">
                                                                    mdi-information-variant
                                                                    </v-icon>
                                                                </v-expansion-panel-header>
                                                                <v-expansion-panel-content class="info-dropdown">
                                                                    <div v-html="$t('zz_gallery_explainer')">
                                                                    </div>
                                                                </v-expansion-panel-content>
                                                            </v-expansion-panel>
                                                        </v-expansion-panels>
                                                    </div>
                                                </template>
                                                <v-row class="pa-3 ma-0">
                                                    <v-col  md="12" cols="12">
                                                        {{$t('zz_gallery')}}
                                                    </v-col>
                                                    <v-col v-for="(item,index) in bgallery" :key="index" md="3" cols="12" class="img_wrp">
                                                        <img :src="item.imageurl" class="imgResponsiveMax" append-icon="mdi-close-box-outline" height="150">
                                                        <v-icon class="close" @click="delelteImage(index)">mdi-close-box-outline</v-icon>
                                                    </v-col>
                                                </v-row>
                                                <v-file-input
                                                            multiple
                                                            accept="image/png, image/jpeg, image/bmp, image/svg"
                                                            placeholder="Pick an Gallery Images"
                                                            prepend-icon="mdi-camera"
                                                            label="Gallery Image"
                                                            :id="'img'+index"
                                                            name="imageurl[]"
                                                        ></v-file-input>
                                                <!-- <v-row v-for="(item, index) in galleries" :key="index" class="pa-3 ma-0">
                                                    <v-col cols="12" md="11">
                                                        <v-file-input
                                                            multiple
                                                            accept="image/png, image/jpeg, image/bmp, image/svg"
                                                            placeholder="Pick an Gallery Images"
                                                            prepend-icon="mdi-camera"
                                                            label="Gallery Image"
                                                            :id="'img'+index"
                                                            :name="'imageurl['+index+']'"
                                                        ></v-file-input>
                                                    </v-col>
                                                    <v-col cols="12" md="1" sm="1" justify="right" align="right">
                                                        <v-row class="">
                                                            <v-col cols="12" md="12" sm="12">
                                                            <a @click="galleries.splice(index, 1)"><v-icon  style="color:red">mdi-delete</v-icon></a>
                                                            </v-col>
                                                        </v-row>
                                                    </v-col>
                                                </v-row>
                                                <v-row class="pa-3">
                                                    <v-col cols="12" md="12" sm="12" class="text-left">
                                                        <v-btn class="add " color="primary" @click="addgallery">Add Gallery</v-btn>
                                                    </v-col>
                                                </v-row> -->
                                            </v-card>


                                        <!-- TERMS & CONDITIONS      -->
                                      <v-col cols="12" md="4">
                                        <v-expansion-panel class="d-none">
                                            <v-expansion-panel-header>Terms & Conditions</v-expansion-panel-header>
                                            <v-expansion-panel-content>
                                                <v-row align="center" justify="center">
                                                    <v-col cols="12" md="12" sm="12" class="caption">
                                                        All the details entered in this section will be visible publicly.<br>
                                                        You confirm that you are legally permitted to enter details.<br>
                                                        We do not sell or give your details to any third parties.<br>
                                                        You agree to allowing Juzzap.com to display the details entered free of any time limit or restrictions.<br>

                                                    </v-col>
                                                    <v-col cols="12" md="12">
                                                        <v-checkbox
                                                        v-model="confirmation"
                                                        name="confirmation"
                                                        label="Please tick to confirm your full acceptance to The Terms & Conditions"
                                                        value="1"
                                                        v-validate="'required'"
                                                        :error-messages="errors.collect('confirmation')"
                                                        data-vv-name="confirmation"
                                                        required
                                                        ></v-checkbox>
                                                    </v-col>
                                                </v-row>
                                           </v-expansion-panel-content>

                                        </v-expansion-panel>
                                    </v-col>
                                </v-row>
                            </v-expansion-panels>
                        </v-form>
            </v-card-text>

            <v-footer padless fixed class="footer-1">
                <v-row class="py-2 pl-5">
                    <v-btn class="d-none d-md-flex px-3 px-2 ma-1 footer-buttons" color="#FE5800" elevation="21" large  @click="update">{{$t('zz_update')}}</v-btn>
                    <v-btn class="d-md-none d-lg-none d-xl-none px-3 ma-1 footer-buttons" color="#FE5800" elevation="21" small  @click="update">{{$t('zz_update')}}</v-btn>
                </v-row>
            </v-footer>




            <!-- <v-footer padless fixed class="footer-1">
                <v-row no-gutters>
                    <v-col cols="12">
                        <v-btn class="d-none d-md-flex px-3 pl-5 ma-5" color="#FE5800" elevation="21" x-large @click="update">{{$t('zz_update')}}</v-btn>
                        <v-btn class="d-md-none d-lg-none d-xl-none px-3 pl-5 ma-5" color="#FE5800" elevation="21" small @click="update">{{$t('zz_update')}}</v-btn>
                    </v-col>
                </v-row>
            </v-footer> -->
            <!-- <v-footer fixed  >
                <v-col class="text-center" cols="12">
                    <v-btn color="primary" block large @click="update">Update</v-btn>
                </v-col>
            </v-footer> -->
         </v-card>





    </v-container>
</template>

<script>
import Vue from 'vue'
import moment from 'moment';
import Editor from '@tinymce/tinymce-vue'
import { Cropper } from 'vue-advanced-cropper'
import VeeValidate from "vee-validate";
Vue.use(VeeValidate);


export default {
    props:
    {
        source: String
    },
    data: vm =>
    ({
        lcode:"",
        lphoto:"",
        openallyear:true,
        taxpayable:true,
        billing_business_name:'',
        billing_taxcode:'',
        billing_address1:'',
        billing_address2:'',
        billing_address3:'',
        billing_address4:'',
        billing_postalcode:'',
        billing_country:'',
        billing_contactname:'',
        billing_contactnumber:'',
        billing_email:'',

        shw:true,
        nshw:false,
        payshw:true,
        paynshw:false,
        currency_id:'7',
        paymentenabled:false,
        businessdescriptiondata:[],
        businessdescriptionlanguagecode:"",
        businessdescriptionlanguagecodearr:[],
        businessdescriptiontranslatorarr:[],
        desccriptiontype:"",
        businessdescriptiontranslator:"",
        descriptiondialog:false,
        //dateFormatted: vm.formatDate(new Date().toISOString().substr(0, 10)),
        menu2: false,
        menu3: false,

        languages: "",
        langdata:[],
        lang: [],
        numberOfEmployees:0,
        currencies:[],
        viewtypelist:[{name:"Grid",value:"Grid"},{name:"List",value:"List"}],
        viewtype:'List',
       panelgallery:[0,1],
       panelthemecolor:[0,1],
       panelhours:[0,1],
       bgallery:[],
       galleries:[{'imageurl':''}],
       uploadedimage:null,

       logoimage:null,
       loveimg:null,
       overviewimage:null,
       overimage:null,
       contactimg:null,
       contactimage:null,
       editorData: '',

        // editorConfigDescription: {height: 200,
        //  menubar: false,
        //  plugins: [
        //    'advlist autolink lists link image charmap print preview anchor',
        //    'searchreplace visualblocks code fullscreen',
        //    'insertdatetime media table paste code wordcount autoresize'
        //  ],
        //  toolbar:
        //    'undo redo | bold italic forecolor backcolor| \
        //    alignleft aligncenter alignright alignjustify | \
        //    bullist numlist outdent indent | link image anchor'
        //    },

        editorConfigDescription: {height: 200,
         menubar: false,

         toolbar:
           ' bold italic | alignleft aligncenter alignright alignjustify'
           },
        facebook:'',
        tripadvisor:'',
        juzzapLogo: require("@/assets/logo-Copy.png"),
        panel: [0,1,2,3,4,5, 6, 7, 8,9],
        valid:false,
        id:"",
        code:"",
        key:"",
        bannerImg:require('@/assets/overview-banner.jpg'),
        stripelogo:require('@/assets/Stripe_wordmark_blurple.svg'),
        address:"",
        loading:false,
        storeBusiness:[],
        data:[],
        visitid:'',
        permited_internal_capacity:'0',
        permited_external_capacity:'0',
        editcapacity:0,
        overlay: false,
        mobile:"",
        whatsapp:"",
        website:"",
        mondayopening:"0",
        mondayclosing:"0",
        tuesdayopening:"0",
        tuesdayclosing:"0",
        wednesdayopening:"0",
        wednesdayclosing:"0",
        thursdayopening:"0",
        thursdayclosing:"0",
        fridayopening:"0",
        fridayclosing:"0",
        saturdayopening:"0",
        saturdayclosing:"0",
        sundayopening:"0",
        sundayclosing:"0",
        mondayopening2:"0",
        mondayclosing2:"0",
        tuesdayopening2:"0",
        tuesdayclosing2:"0",
        wednesdayopening2:"0",
        wednesdayclosing2:"0",
        thursdayopening2:"0",
        thursdayclosing2:"0",
        fridayopening2:"0",
        fridayclosing2:"0",
        saturdayopening2:"0",
        saturdayclosing2:"0",
        sundayopening2:"0",
        sundayclosing2:"0",
        valid: true,
        businessName: "",
        businessType: "",
        email: "",
        phone: "",
        contactName:"",
        contactPosition:"",
        contactEmail:"",
        contactPhone:"",
        password: "",
        password_confirmation: "",
        addressLine1: "",
        addressLine2: "",
        addressLine3: "",
        addressLine4: "",
        postcode: "",
        types: [],
        confirmation:"",
        description:'',
        alwaysopen:false,
        languagelist:[{name:"English",value:"en"},
                    {name:"Spanish",value:"es"},
                    {name:"French",value:"fr"},
                    {name:"German",value:"de"},
                    {name:"Russian",value:"ru"},],
        times:[{name:"Allways Open",value:"alwaysopen"},
            {name:"Closed",value:"0"},
            {name:"00:00",value:"00:00"},
            {name:"00:30",value:"00:30"},
            {name:"01:00",value:"01:00"},
            {name:"01:30",value:"01:30"},
            {name:"02:00",value:"02:00"},
            {name:"02:30",value:"02:30"},
            {name:"03:00",value:"03:00"},
            {name:"03:30",value:"03:30"},
            {name:"04:00",value:"04:00"},
            {name:"04:30",value:"04:30"},
            {name:"05:00",value:"05:00"},
            {name:"05:30",value:"05:30"},
            {name:"06:00",value:"06:00"},
            {name:"06:30",value:"06:30"},
            {name:"07:00",value:"07:00"},
            {name:"07:30",value:"07:30"},
            {name:"08:00",value:"08:00"},
            {name:"08:30",value:"08:30"},
            {name:"09:00",value:"09:00"},
            {name:"09:30",value:"09:30"},
            {name:"10:00",value:"10:00"},
            {name:"10:30",value:"10:30"},
            {name:"11:00",value:"11:00"},
            {name:"11:30",value:"11:30"},
            {name:"12:00",value:"12:00"},
            {name:"12:30",value:"12:30"},
            {name:"13:00",value:"13:00"},
            {name:"13:30",value:"13:30"},
            {name:"14:00",value:"14:00"},
            {name:"14:30",value:"14:30"},
            {name:"15:00",value:"15:00"},
            {name:"15:30",value:"15:30"},
            {name:"16:00",value:"16:00"},
            {name:"16:30",value:"16:30"},
            {name:"17:00",value:"17:00"},
            {name:"17:30",value:"17:30"},
            {name:"18:00",value:"18:00"},
            {name:"18:30",value:"18:30"},
            {name:"19:00",value:"19:00"},
            {name:"19:30",value:"19:30"},
            {name:"20:00",value:"20:00"},
            {name:"20:30",value:"20:30"},
            {name:"21:00",value:"21:00"},
            {name:"21:30",value:"21:30"},
            {name:"22:00",value:"22:00"},
            {name:"22:30",value:"22:30"},
            {name:"23:00",value:"23:00"},
            {name:"23:30",value:"23:30"}],

        dictionary: {
        attributes: {
            email: "E-mail Address",
            businessName: "Business Name",
            businessType: "Business Type",
            confirmation:"Confirm your full acceptgance",


        },
        custom: {}
        },
        businessactivities:[],
        businessactivity_id:0,
        externalcapacity:"",
        internalcapacity:"",
        country:"",
        haseatin:false,
        hastakeaway:false,
        hasdelivery:false,
        contactimguploading:false,
        coverimguploading:false,
        logoimageuploading:false,
        image:null,
        themecolor:'#FE5800',
        socialmedia:[],
        socialmediadata:[],
        languagetranslations:[],
        translationlanguages:[],
        socialmedia:[{'id':'','socialmedia':'','value':''}],
        socialmedia_id:"",
        socialmedias:[],
        facilities:[{'id':'','facility':'','link':'','description':''}],
        facilitiy:[],
        facilities_id:"",
        // fromdate: new Date().toISOString().substr(0, 10),
        // enddate: new Date().toISOString().substr(0, 10),
        fromdate: '',
        enddate: '',

        // dateFormatted: vm.formatDate(new Date().toISOString().substr(0, 10)),
        dateFormatted:'',
        menu3: false,
        menu2: false,

        itemdescription:[{'id':'','languagecode':'','description':'','business_id':''}],
        businesslangdata:[],
        dialog:false,
        langexist:false,
        stripsecretkey:'',
        stripapikey:'',
        lang2:[],
        countries:[],
  }),
    watch:
    {
      fromdate (val) {
        this.dateFormatted = this.formatDate(this.fromdate)
      },
      enddate(val)
      {
        this.dateFormatted = this.formatDate(this.enddate)
      }
    },
    computed:
    {
        // isAuthorised() {
        // return this.$store.getters.isLoggedin;
        // },
        computedDateFormatted () {
        return this.formatDate(this.fromdate)
        },

        computedDateFormattedEnd(){
        return this.formatDate(this.enddate)
        },
    },
    mounted()
    {
        this.storeBusiness=JSON.parse(this.$store.getters.business);

        //    if (this.$route.params.id)
     //    {
        //     this.id = this.$route.params.id;
        //    }

        this.id=this.storeBusiness.id;
        // this.getBusiness();
        this.fetchBusinessType();
        this.fetchCurrency();
        this.fetchCountries();
        this.fetchBusinessActivity();
        this.fetchdata();
        this.fetchbusinesslangdata();
        this.checklangexist();
        this.fetchSocialMedia();
        this.fetchFacilities();
        this.fetchLang();
        this.fetchbusinessdescription();


    },
    components:
    {
        'editor': Editor,
        Cropper
	},
  methods:
  {

        addtranslator()
        {
            this.itemdescription.push({
            'id':'',
            'languagecode':'',
            'description':'',
            'business_id':'',

            })
        },

        backtobusiness()
        {
            this.descriptiondialog=false;

        },
        translator()
        {
            this.descriptiondialog=true;
        },
        formatDate (date) {
            if (!date) return null

            const [year,month,day ] = date.split('-')
            return `${day}/${month}/${year}`
        },
        parseDate (date)
            {
                if (!date) return null

                const [ day, month,year] = date.split('/')
                return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
        },
        remove (item)
        {
            const index = this.data.languages.indexOf(item.name)
            console.log(item.name+' index '+ this.data.languages.indexOf(item.name));
            if (index >= 0) this.data.languages.splice(index, 1)
        },

        fetchLang()
        {
            this.$http
            .get(this.$apidomain+"languageslist")
            .then(res => {
            this.lang = res.data.languages;
            })
            .catch(err => {
            console.log(err.response);
            });
        },


        fetchLangCode()
        {
            this.$http
            .get(this.$apidomain+"languageslistcode/"+this.languages)
            .then(res => {
            this.lang2 = res.data.languages;
            })
            .catch(err => {
            console.log(err.response);
            });
        },

        fetchCurrency()
        {
            this.$http
            .get(this.$apidomain+"business/currencylist")
            .then(res => {
                this.currencies = res.data.currencies;
                //console.log("types "+ this.types);
            })
            .catch(err => {
                console.log(err.response);
            });
        },
        onChangeContactImage({coordinates, canvas})
        {
            this.contactimguploading=false;

            this.coordinates = coordinates

            this.contactimg = canvas.toDataURL()
        },
        contactim(event)
        {
        var input = event.target;
            // Ensure that you have a file before attempting to read it
        if (input.files && input.files[0]) {
                this.contactimguploading=true;

                // create a new FileReader to read this image and convert to base64 format
                var reader = new FileReader();
                // Define a callback function to run, when FileReader finishes its job
                reader.onload = (e) => {
                    // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
                    // Read image as base64 and set to imageData
                    this.contactimage = e.target.result;
                }
                // Start the reader job - read file as a data url (base64 format)
                reader.readAsDataURL(input.files[0]);
            }
        },
        fetchFacilities()
        {
          this.$http
          .get(this.$apidomain+"facilitiesList")
          .then(res => {
          this.facilitiy = res.data.facilities;
          })
          .catch(err => {
            console.log(err.response);
          });
        },
        fetchSocialMedia()
        {
            this.$http
            .get(this.$apidomain+"socialmedialist")
            .then(res => {
                this.socialmedias = res.data.socialmedia;
            })
            .catch(err => {
                console.log(err.response);
            });
        },
        addFacility()
        {

            this.facilities.push({
                        'id':'',
                        'facility':'',
                        'link':'',
                        'description':''

                    })
        },
      add()
      {
        this.socialmedia.push({
                'id':'',
                'socialmedia':'',
                'value':''
            })
      },
        openallyear(){
            this.data.openallyear="openallyear"

        },

        setalwaysopen()
        {
            if(this.alwaysopen)
            {

                this.data.mondayopening='alwaysopen';
                this.data.mondayclosing='alwaysopen';

                this.data.mondayopening2='alwaysopen';
                this.data.mondayclosing2='alwaysopen';

                this.data.tuesdayopening='alwaysopen';
                this.data.tuesdayclosing='alwaysopen';

                this.data.tuesdayopening2='alwaysopen';
                this.data.tuesdayclosing2='alwaysopen';

                this.data.wednesdayopening='alwaysopen';
                this.data.wednesdayclosing='alwaysopen';

                this.data.wednesdayopening2='alwaysopen';
                this.data.wednesdayclosing2='alwaysopen';


                this.data.thursdayopening='alwaysopen';
                this.data.thursdayclosing='alwaysopen';


                this.data.thursdayopening2='alwaysopen';
                this.data.thursdayclosing2='alwaysopen';

                this.data.fridayopening='alwaysopen';
                this.data.fridayclosing='alwaysopen';

                this.data.fridayopening2='alwaysopen';
                this.data.fridayclosing2='alwaysopen';


                this.data.saturdayopening='alwaysopen';
                this.data.saturdayclosing='alwaysopen';

                this.data.saturdayopening2='alwaysopen';
                this.data.saturdayclosing2='alwaysopen';

                this.data.sundayopening='alwaysopen';
                this.data.sundayclosing='alwaysopen';

                this.data.sundayopening2='alwaysopen';
                this.data.sundayclosing2='alwaysopen';



                /*this.mondayopening='alwaysopen';
                this.mondayclosing='alwaysopen';
                this.mondayopening2='alwaysopen';
                this.mondayclosing2='alwaysopen';

                this.tuesdayopening='alwaysopen';
                this.tuesdayclosing='alwaysopen';
                this.tuesdayopening2='alwaysopen';
                this.tuesdayclosing2='alwaysopen';

                this.wednesdayopening='alwaysopen';
                this.wednesdayclosing='alwaysopen';
                this.wednesdayopening2='alwaysopen';
                this.wednesdayclosing2='alwaysopen';

                this.thursdayopening='alwaysopen';
                this.thursdayclosing='alwaysopen';
                this.thursdayopening2='alwaysopen';
                this.thursdayclosing2='alwaysopen';

                this.fridayopening='alwaysopen';
                this.fridayclosing='alwaysopen';
                this.fridayopening2='alwaysopen';
                this.fridayclosing2='alwaysopen';

                this.saturdayopening='alwaysopen';
                this.saturdayclosing='alwaysopen';
                this.saturdayopening2='alwaysopen';
                this.saturdayclosing2='alwaysopen';

                this.sundayopening='alwaysopen';
                this.sundayclosing='alwaysopen';
                this.sundayopening2='alwaysopen';
                this.sundayclosing2='alwaysopen';*/


            }else{


                this.data.mondayopening=this.mondayopening;
                this.data.mondayclosing=this.mondayclosing;

                this.data.mondayopening2=this.mondayopening2;
                this.data.mondayclosing2=this.mondayclosing2;

                this.data.tuesdayopening=this.tuesdayopening;
                this.data.tuesdayclosing=this.tuesdayclosing;


                this.data.tuesdayopening2=this.tuesdayopening2;
                this.data.tuesdayclosing2=this.tuesdayclosing2;

                this.data.wednesdayopening=this.wednesdayopening;
                this.data.wednesdayclosing=this.wednesdayclosing;

                this.data.wednesdayopening2=this.wednesdayopening2;
                this.data.wednesdayclosing2=this.wednesdayclosing2;

                this.data.thursdayopening=this.thursdayopening;
                this.data.thursdayclosing=this.thursdayclosing;

                this.data.thursdayopening2=this.thursdayopening2;
                this.data.thursdayclosing2=this.thursdayclosing2;

                this.data.fridayopening=this.fridayopening;
                this.data.fridayclosing=this.fridayclosing;


                this.data.fridayopening2=this.fridayopening2;
                this.data.fridayclosing2=this.fridayclosing2;


                this.data.saturdayopening=this.saturdayopening;
                this.data.saturdayclosing=this.saturdayclosing;


                this.data.saturdayopening2=this.saturdayopening2;
                this.data.saturdayclosing2=this.saturdayclosing2;


                this.data.sundayopening=this.sundayopening;
                this.data.sundayclosing=this.sundayclosing;

                this.data.sundayopening2=this.sundayopening2;
                this.data.sundayclosing2=this.sundayclosing2;

                /*this.mondayopening='0';
                this.mondayclosing='0';
                this.mondayopening2='0';
                this.mondayclosing2='0';

                this.tuesdayopening='0';
                this.tuesdayclosing='0';
                this.tuesdayopening2='0';
                this.tuesdayclosing2='0';

                this.wednesdayopening='0';
                this.wednesdayclosing='0';
                this.wednesdayopening2='0';
                this.wednesdayclosing2='0';

                this.thursdayopening='0';
                this.thursdayclosing='0';
                this.thursdayopening2='0';
                this.thursdayclosing2='0';

                this.fridayopening='0';
                this.fridayclosing='0';
                this.fridayopening2='0';
                this.fridayclosing2='0';

                this.saturdayopening='0';
                this.saturdayclosing='0';
                this.saturdayopening2='0';
                this.saturdayclosing2='0';

                this.sundayopening='0';
                this.sundayclosing='0';
                this.sundayopening2='0';
                this.sundayclosing2='0';*/


            }
        },
        uploadImage(event)
        {
            // Reference to the DOM input element
            var input = event.target;
            // Ensure that you have a file before attempting to read it
            if (input.files && input.files[0])
            {
                // create a new FileReader to read this image and convert to base64 format
                var reader = new FileReader();
                this.logoimageuploading=true;
                // Define a callback function to run, when FileReader finishes its job
                reader.onload = (e) => {
                    // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
                    // Read image as base64 and set to imageData
                    this.uploadedimage = e.target.result;

                }
                // Start the reader job - read file as a data url (base64 format)
                reader.readAsDataURL(input.files[0]);

            }
        },
        overimg(event)
        {
            var input = event.target;
                // Ensure that you have a file before attempting to read it
            if (input.files && input.files[0])
            {
                this.coverimguploading=true;
                // create a new FileReader to read this image and convert to base64 format
                var reader = new FileReader();

                // Define a callback function to run, when FileReader finishes its job
                reader.onload = (e) => {
                        // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
                        // Read image as base64 and set to imageData
                        this.overviewimage = e.target.result;

                    }
                    // Start the reader job - read file as a data url (base64 format)
                    reader.readAsDataURL(input.files[0]);

            }

        },
        saturdayTime()
        {
            this.storeBusiness.sundayopening=this.storeBusiness.saturdayopening;
            this.storeBusiness.sundayclosing=this.storeBusiness.saturdayclosing;
            this.storeBusiness.sundayopening2=this.storeBusiness.saturdayopening2;
            this.storeBusiness.sundayclosing2=this.storeBusiness.saturdayclosing2;
        },
        fridayTime()
        {
            this.storeBusiness.saturdayopening=this.storeBusiness.fridayopening;
            this.storeBusiness.saturdayclosing=this.storeBusiness.fridayclosing;
            this.storeBusiness.saturdayopening2=this.storeBusiness.fridayopening2;
            this.storeBusiness.saturdayclosing2=this.storeBusiness.fridayclosing2;

        },
        thursdayTime()
        {
            this.storeBusiness.fridayopening=this.storeBusiness.thursdayopening;
            this.storeBusiness.fridayclosing=this.storeBusiness.thursdayclosing;
            this.storeBusiness.fridayopening2=this.storeBusiness.thursdayopening2;
            this.storeBusiness.fridayclosing2=this.storeBusiness.thursdayclosing2;

        },
        wednesdayTime()
        {

            this.storeBusiness.thursdayopening=this.storeBusiness.wednesdayopening;
            this.storeBusiness.thursdayclosing=this.storeBusiness.wednesdayclosing;
            this.storeBusiness.thursdayopening2=this.storeBusiness.wednesdayopening2;
            this.storeBusiness.thursdayclosing2=this.storeBusiness.wednesdayclosing2;

        },
        tuesdayTime()
        {

            this.storeBusiness.wednesdayopening=this.storeBusiness.tuesdayopening;
            this.storeBusiness.wednesdayclosing=this.storeBusiness.tuesdayclosing;
            this.storeBusiness.wednesdayopening2=this.storeBusiness.tuesdayopening2;
            this.storeBusiness.wednesdayclosing2=this.storeBusiness.tuesdayclosing2;

        },
        mondayTime()
        {

            this.storeBusiness.tuesdayopening=this.storeBusiness.mondayopening;
            this.storeBusiness.tuesdayopening=this.storeBusiness.mondayopening;
            this.storeBusiness.tuesdayclosing=this.storeBusiness.mondayclosing;
            this.storeBusiness.tuesdayopening2=this.storeBusiness.mondayopening2;
            this.storeBusiness.tuesdayclosing2=this.storeBusiness.mondayclosing2;

        },
        fetchBusinessActivity()
        {
            this.$http
            .get(this.$apidomain+"businessActivityList")
            .then(res => {
            this.businessactivities = res.data.businessActivities;
            })
            .catch(err => {
            console.log(err.response);
            });
        },

        fetchBusinessType()
        {
            this.$http
            .get(this.$apidomain+"businesstypelist")
            .then(res => {
                this.types = res.data.businessType;
                //console.log("types "+ this.types);
            })
            .catch(err => {
                console.log(err.response);
            });
        },

        fetchCountries()
        {
            this.$http
            .get(this.$apidomain+"countrylist")
            .then(res => {
                this.countries = res.data.country;
                //console.log("types "+ this.types);
            })
            .catch(err => {
                console.log(err.response);
            });
        },

        addgallery()
        {
         this.galleries.push({'imageurl':''})
        },
        delelteLogoImage()
        {
            this.$http
            .post(this.$apidomain+"businessdeletelogoimages/"+ this.id)
            .then(res => {
                this.business=res.data.business;
                this.$router.go();
                //console.log("types "+ this.types);
            })
            .catch(err => {
                console.log(err.response);
            });
        },
        delelteCoverImage()
        {
            this.$http
            .post(this.$apidomain+"businessdeletecoverimages/"+ this.id)
            .then(res => {
                this.business=res.data.business;
                this.$router.go();
                //console.log("types "+ this.types);
            })
            .catch(err => {
                console.log(err.response);
            });
        },
        delelteContactImage()
        {
            this.$http
            .post(this.$apidomain+"businessdeletecontactimages/"+ this.id)
            .then(res => {
                this.business=res.data.business;
                this.$router.go();
                //console.log("types "+ this.types);
            })
            .catch(err => {
                console.log(err.response);
            });
        },
        delelteImage(index)
        {
            this.$http
            .post(this.$apidomain+"businessdeleteimages/"+ this.id+'/'+index)
            .then(res => {
                this.bgallery=res.data.bgallery;
                //console.log("types "+ this.types);
            })
            .catch(err => {
                console.log(err.response);
            });
        },


      fetchbusinessdescription()
      {
          this.overlay=true;
          this.$http
        .get(this.$apidomain+"businessdescriptiondata/" + this.id)
        .then(res => {
          if(res.data.success==1)
          {
              this.data=res.data.businessdescription;

              this.itemdescription=res.data.businessdescription;

              this.businessdescriptiondata=res.data.businessdescription;

              this.businessdescriptionlanguagecode=res.data.businessdescription.languagecode;

              this.businessdescriptiontranslator=res.data.businessdescription.description;

                this.overlay=false;


          }
          else
          {

              this.overlay=false;




            // console.log(res.data.businesses);
          }
        })
        .catch(err => {
          console.log(err.response);
        });
      },

      checklangexist()
      {
            let lexist=false;

            this.$http
            .get(this.$apidomain+"checklanguagecodeexist/"+this.id)
            .then(res => {
                if(res.data.success==1)
                {


                    lexist=true;
                    this.langexist=true;

                }
                else
                {
                    lexist=false;
                    this.langexist=false;
                }

                // return lexist;
                return this.langexist;

            })
            .catch(err => {
                console.log(err.response);
                //this.overlay=false;

            });
      },

      checklangactive(langcode)
      {

        let lcode=langcode;

        // if(!this.businesslangdata.some(data => data.id === 1))
        // {

        // }

        let rs=false;

        this.businesslangdata.forEach(function(it,ind)
        {
            if(it.languagecode==lcode && it.active==1)
            {
                rs=true;
            }

        });

        return rs;

      },

      updatelanguageactive(langcode,active)
      {
                this.$http
                .post(this.$apidomain+"updateactivelanguage/"+this.id,{langcode:langcode,active:active})
                .then(res => {
                    if(res.data.success==1)
                    {


                        this.$router.go('/');
                    }



                })
                .catch(err => {
                    console.log(err.response);
                    //this.overlay=false;

                });

      },

      fetchbusinesslangdata()
      {

          this.$http
        .get(this.$apidomain+"businesslangdata/" + this.id)
        .then(res => {
          if(res.data.success==1)
          {
                this.businesslangdata=res.data.businesslangdata;




          }

        })
        .catch(err => {
          console.log(err.response);
        });
      },

      fetchdata()
      {
        this.overlay=true;
        this.$http
        .get(this.$apidomain+"businessdata/" + this.id)
        .then(res => {
          if(res.data.success==0)
          {
            //alert('User Have no wright to show other user data !')
             this.$router.push("/agent/businesslist");
             this.overlay=false;

          }
          else
          {
            console.log('success=1');
              this.data=res.data.businesses;

              this.currency_id=parseInt(res.data.businesses.currency_id);

              this.haseatin=res.data.businesses.haseatin==1?true:false;
              this.hastakeaway=res.data.businesses.hastakeaway==1?true:false;
              this.hasdelivery=res.data.businesses.hasdelivery==1?true:false;
              this.lcode=res.data.businesses.lcode;

              this.lphoto=res.data.businesses.lphoto;


              this.viewtype=res.data.businesses.viewtype;

              this.paymentenabled=res.data.businesses.paymentenabled;

              this.stripapikey=res.data.businesses.stripapikey;

              this.stripsecretkey=res.data.businesses.stripsecretkey;


              this.mondayopening=res.data.businesses.mondayopening;
            this.mondayclosing=res.data.businesses.mondayclosing;

            this.mondayopening2=res.data.businesses.mondayopening2;
            this.mondayclosing2=res.data.businesses.mondayclosing2;


            this.tuesdayopening=res.data.businesses.tuesdayopening;
            this.tuesdayclosing=res.data.businesses.tuesdayclosing;

            this.tuesdayopening2=res.data.businesses.tuesdayopening2;
            this.tuesdayclosing2=res.data.businesses.tuesdayclosing2;


            this.wednesdayopening=res.data.businesses.wednesdayopening;
            this.wednesdayclosing=res.data.businesses.wednesdayclosing;

            this.wednesdayopening2=res.data.businesses.wednesdayopening2;
            this.wednesdayclosing2=res.data.businesses.wednesdayclosing2;


            this.thursdayopening=res.data.businesses.thursdayopening;
            this.thursdayclosing=res.data.businesses.thursdayclosing;

            this.thursdayopening2=res.data.businesses.thursdayopening2;
            this.thursdayclosing2=res.data.businesses.thursdayclosing2;


            this.fridayopening=res.data.businesses.fridayopening;
            this.fridayclosing=res.data.businesses.fridayclosing;


            this.fridayopening2=res.data.businesses.fridayopening2;
            this.fridayclosing2=res.data.businesses.fridayclosing2;


            this.saturdayopening=res.data.businesses.saturdayopening;
            this.saturdayclosing=res.data.businesses.saturdayclosing;


            this.saturdayopening2=res.data.businesses.saturdayopening2;
            this.saturdayclosing2=res.data.businesses.saturdayclosing2;

            this.sundayopening=res.data.businesses.sundayopening;
            this.sundayclosing=res.data.businesses.sundayclosing;

            this.sundayopening2=res.data.businesses.sundayopening2;
            this.sundayclosing2=res.data.businesses.sundayclosing2;





              this.storeBusiness=res.data.businesses;

              this.themecolor=this.storeBusiness.themecolor;
              this.$vuetify.theme.themes.light.accent = '#fe5800';

              if(this.data.languagecode!=null)
                {
                    //this.data.languages=this.data.languagecode.split(',');
                    this.languages=this.data.languagecode;
                }

             if(this.storeBusiness.hastakeaway)
             {
                 this.storeBusiness.hastakeaway=true;
             }else{
                 this.storeBusiness.hastakeaway=false;

             }

             if(this.storeBusiness.haseatin)
             {
                 this.storeBusiness.haseatin=true;
             }else{
                 this.storeBusiness.haseatin=false;

             }

             if(this.storeBusiness.hasdelivery)
             {
                 this.storeBusiness.hasdelivery=true;
             }else{
                 this.storeBusiness.hasdelivery=false;

             }



              this.businessName=this.storeBusiness.businessName  ;
              this.businessType=this.data.businessType;
              this.image=this.data.logo;
              this.bimage=this.data.backgroundimage;
              this.contactimg=this.data.contactimage;
              this.overimage=this.data.overviewimage;
              this.tingsimage=this.data.thingsimage;
              this.teamimg=this.data.teamimage;
              this.loveimg=this.data.loveimage;
              this.businessactivity_id=parseInt(res.data.businesses.businessactivity_id);
              this.welcomemsg=res.data.businesses.welcomemsg;
              this.description=res.data.businesses.description;
              this.shortdescription=res.data.businesses.shortdescription;
              this.creater_id=res.data.user_id;
              this.alwaysopen=res.data.businesses.alwaysopen;
              if(this.alwaysopen){
                this.alwaysopen=true;
              }
              else{
                this.alwaysopen=false;
              }
              this.openallyear=res.data.businesses.openallyear;
              if(this.openallyear){
                this.openallyear=true;
              }
              else{
                this.openallyear=false;
              }
              this.businessName = res.data.businesses.businessName;
              //this.businessType = res.data.businesses.businessType;
              this.numberOfEmployees = res.data.businesses.numberOfEmployees;
              this.taxpayable=res.data.businesses.taxpayable;
              this.email = res.data.businesses.email;
              this.phone = res.data.businesses.phone;
              this.contactName = res.data.businesses.contactName;
              this.contactPosition = res.data.businesses.contactPosition;
              this.contactEmail = res.data.businesses.contactEmail;
              this.contactPhone = res.data.businesses.contactPhone;



                this.billing_business_name=res.data.businesses.billing_business_name;
                this.billing_taxcode=res.data.businesses.billing_taxcode;
                this.billing_address1=res.data.businesses.billing_address1;
                this.billing_address2=res.data.businesses.billing_address2;
                this.billing_address3=res.data.businesses.billing_address3;
                this.billing_address4=res.data.businesses.billing_address4;
                this.billing_postalcode=res.data.businesses.billing_postalcode;
                this.billing_country=res.data.businesses.billing_country;
                this.billing_contactname=res.data.businesses.billing_contactname;
                this.billing_contactnumber=res.data.businesses.billing_contactnumber;
                this.billing_email=res.data.businesses.billing_email;

              this.addressLine1 = res.data.businesses.addressLine1;
              this.addressLine2 = res.data.businesses.addressLine2;
              this.addressLine3 = res.data.businesses.addressLine3;
              this.addressLine4 = res.data.businesses.addressLine4;
              this.postcode = res.data.businesses.postcode;
              this.facebook = res.data.businesses.facebook;
              this.tripadvisor = res.data.businesses.tripadvisor;
              this.googlemaps = res.data.businesses.googlemaps;
             // console.log(res.data.businesses.translationlanguages);
              this.translationlanguages=res.data.businesses.translationlanguages;
              this.languagetranslations=res.data.businesses.languagetranslations;



             if(res.data.socialmedia.length!=0)

             {
                this.socialmedia=res.data.socialmedia;

                // if(this.socialmedia)
                // {
                //     if(this.socialmedia[0].value!='')
                //     {
                //         this.tripadvisor=this.socialmedia[0].value;

                //     }
                //     if(this.socialmedia[1].value!='')
                //     {
                //         this.facebook=this.socialmedia[1].value;

                //     }

                // }
             }


              this.facilities=res.data.facilities;
              this.bgallery=res.data.bgallery;

              this.fetchLangCode();
              this.overlay=false;




            // console.log(res.data.businesses);
          }
        })
        .catch(err => {
          console.log(err.response);
        });
    },
      onChangeOverView({coordinates, canvas})
        {

            this.coordinates = coordinates
            this.overimage = canvas.toDataURL()
            this.coverimguploading=false;
        },
         onChangelogo({coordinates, canvas})
        {
            this.coordinates = coordinates
            this.logoimage = canvas.toDataURL()
        },
      onChange({coordinates, canvas}) {

			this.coordinates = coordinates
			// You able to do different manipulations at a canvas
			// but there we just get a cropped image
      this.image = canvas.toDataURL()
       this.logoimageuploading=false;
        },
      dataURLtoFile(dataurl, filename)
        {

            var arr = dataurl.split(','),
                mime = arr[0].match(/:(.*?);/)[1],
                bstr = atob(arr[1]),
                n = bstr.length,
                u8arr = new Uint8Array(n);

            while(n--){
                u8arr[n] = bstr.charCodeAt(n);
            }

            return new File([u8arr], filename, {type:mime});
        },
        updatedescription()
        {
            let th = this;
            if (this.$validator.validateAll())
            {

                let fd = new FormData(document.getElementById("editbusinessdesccription"));

                fd.append('type','update');

                fd.append('itemdescription',JSON.stringify(this.itemdescription));


                // fd.append('languagecode',th.businessdescriptionlanguagecodearr);

                // fd.append('businessdescription',th.businessdescriptiontranslatorarr);

                this.$http
                .post(this.$apidomain+"updatebusinessdescription/"+ this.id, fd)
                .then(res => {
                if(res.data.success)
                {
                    this.descriptiondialog=false;
                    this.fetchdata();
                }
                else
                {
                    let errmsg=[];
                    for(var prop in res.data.errors){
                        errmsg.push(res.data.errors[prop][0]);
                    }
                    this.overlay=false;
                    alert(errmsg[0]);
                    this.descriptiondialog=false;


                }
                })
                .catch(err => {
                    console.log(err.response);
                    this.overlay=false;
                });
            }
        },
        createdescription()
        {
            let th = this;
            if (this.$validator.validateAll())
            {

                let fd = new FormData(document.getElementById("editbusinessdesccription"));

                fd.append('type','update');

                fd.append('languagecode',th.businessdescriptionlanguagecode);

                fd.append('businessdescription',th.businessdescriptiontranslator);

                this.$http
                .post(this.$apidomain+"createbusinessdescription/"+ this.id, fd)
                .then(res => {
                if(res.data.success)
                {
                    this.descriptiondialog=false;
                    this.fetchdata();
                }
                else
                {
                    let errmsg=[];
                    for(var prop in res.data.errors){
                        errmsg.push(res.data.errors[prop][0]);
                    }
                    this.overlay=false;
                    alert(errmsg[0]);
                    this.descriptiondialog=false;


                }
                })
                .catch(err => {
                    console.log(err.response);
                    this.overlay=false;
                });
            }
        },
        update()
        {
            let th = this;
            if (this.$validator.validateAll())
            {
                let fd = new FormData(document.getElementById("editbusinessregister"));
                //fd.append('businessactivity_id',this.data.businessactivity_id);

                // if(this.data.paymentenabled)
                // {
                // fd.append('paymentenabled',1);
                // }
                // else{
                // fd.append('paymentenabled',0);

                // }

                if(this.taxpayable==true)
                {
                    fd.append('taxpayable',1);
                }
                else{
                    fd.append('taxpayable',0);

                }




                if(this.paymentenabled==true)
                {
                fd.append('paymentenabled',1);
                }
                else{
                fd.append('paymentenabled',0);

                }

                // fd.append('stripapikey',this.storeBusiness.stripapikey);

                // fd.append('stripsecretkey',this.storeBusiness.stripsecretkey);

                fd.append('viewtype',th.viewtype);
                fd.append('businessactivity_id',th.businessactivity_id);

                if(this.currency_id)
                {
                    fd.append('currency_id',this.currency_id);
                }
                else
                {
                    fd.append('currency_id',7);

                }

                fd.append("businessType", this.storeBusiness.businessType);

                fd.append("deliverynotes",this.storeBusiness.deliverynotes)

                fd.set("haseatin",this.haseatin?1:0);

                fd.set("hastakeaway",this.hastakeaway?1:0);

                fd.set("hasdelivery",this.hasdelivery?1:0);

                fd.append("country",this.storeBusiness.country);

                fd.append('billing_country',this.billing_country);

                fd.append('description',this.description);

                fd.append('themecolor',this.themecolor);

                fd.append('businessName',this.businessName);

                //fd.append('languagecode',th.data.languages);
                fd.append('languagecode',th.languages);
                fd.append('translationlanguages',JSON.stringify(th.translationlanguages));
                if(this.contactimage!=null)
                {
                fd.append('contactimage',this.dataURLtoFile(this.contactimg,document.getElementById('contactimg').files[0].name));
                }

                if(this.overviewimage!=null)
                {
                    fd.append('overviewimage',this.dataURLtoFile(this.overimage,document.getElementById('overimage').files[0].name));
                }

                if(this.uploadedimage!=null)
                {
                    fd.append('imagea',this.dataURLtoFile(this.image,document.getElementById('logo').files[0].name));
                }

                fd.append("mondayopening",this.storeBusiness.mondayopening);
                fd.append("mondayclosing",this.storeBusiness.mondayclosing);
                fd.append("mondayopening2",this.storeBusiness.mondayopening2);
                fd.append("mondayclosing2",this.storeBusiness.mondayclosing2);

                fd.append("tuesdayopening",this.storeBusiness.tuesdayopening);
                fd.append("tuesdayclosing",this.storeBusiness.tuesdayclosing);
                fd.append("tuesdayopening2",this.storeBusiness.tuesdayopening2);
                fd.append("tuesdayclosing2",this.storeBusiness.tuesdayclosing2);


                fd.append("wednesdayopening",this.storeBusiness.wednesdayopening);
                fd.append("wednesdayclosing",this.storeBusiness.wednesdayclosing);
                fd.append("wednesdayopening2",this.storeBusiness.wednesdayopening2);
                fd.append("wednesdayclosing2",this.storeBusiness.wednesdayclosing2);

                fd.append("thursdayopening",this.storeBusiness.thursdayopening);
                fd.append("thursdayclosing",this.storeBusiness.thursdayclosing);
                fd.append("thursdayopening2",this.storeBusiness.thursdayopening2);
                fd.append("thursdayclosing2",this.storeBusiness.thursdayclosing2);

                fd.append("fridayopening",this.storeBusiness.fridayopening);
                fd.append("fridayclosing",this.storeBusiness.fridayclosing);
                fd.append("fridayopening2",this.storeBusiness.fridayopening2);
                fd.append("fridayclosing2",this.storeBusiness.fridayclosing2);


                fd.append("saturdayopening",this.storeBusiness.saturdayopening);
                fd.append("saturdayclosing",this.storeBusiness.saturdayclosing);
                fd.append("saturdayopening2",this.storeBusiness.saturdayopening2);
                fd.append("saturdayclosing2",this.storeBusiness.saturdayclosing2);

                fd.append("sundayopening",this.storeBusiness.sundayopening);
                fd.append("sundayclosing",this.storeBusiness.sundayclosing);
                fd.append("sundayopening2",this.storeBusiness.sundayopening2);
                fd.append("sundayclosing2",this.storeBusiness.sundayclosing2);

                fd.append('creater_id','128');

                fd.append('socialmedias',JSON.stringify(this.socialmedia));

                fd.append('facilities',JSON.stringify(this.facilities));
                fd.append('languagetranslations',JSON.stringify(this.languagetranslations));


                this.overlay=true;


                this.$http
                .post(this.$apidomain+"updatebusinessregister/"+ this.id, fd)
                .then(res => {
                if(res.data.success)
                {
                    let businesscode=res.data.business.businesscode;
                    this.storeBusiness=res.data.business;
                    this.$store.dispatch("assignBusiness",JSON.stringify(this.storeBusiness)).then(() => {

                    });


                    //this.$router.push("/businessdashboard");
                   // this.$router.push("/business/profile");
                   // this.$router.go('/');

                    this.fetchdata();

                }
                else
                {
                    let errmsg=[];
                    for(var prop in res.data.errors){
                        errmsg.push(res.data.errors[prop][0]);
                    }
                    this.overlay=false;
                    alert(errmsg[0]);

                }
                })
                .catch(err => {
                    console.log(err.response);
                    this.overlay=false;
                });
            }
        },
  }
}
</script>
<style >

.flagz{
    /* padding-left: 0px; */
    max-height: 20px;
    max-width: 30px;

}

.topbg {
  background: #fe5800;
}
.pwa-content {
  margin-top: -63px !important;
}
/* .txt-color
{

    color: #7697A1;
} */
.v-text-field__details{
  display:none;
}
.v-text-field--filled > .v-input__control > .v-input__slot, .v-text-field--full-width > .v-input__control > .v-input__slot, .v-text-field-- > .v-input__control > .v-input__slot {
	-webkit-box-align: stretch;
	-ms-flex-align: stretch;
	align-items: stretch;
	min-height: 40px !important;
}
.v-expansion-panel-content__wrap{
  padding:18px !important;
}
.v-input--selection-controls:not(.v-input--hide-details) .v-input__slot {
	margin-bottom: 0px !important;
}
.v-input--selection-controls .v-input__control {
	margin-bottom:0px !important;
}
.v-input--selection-controls {
	margin-top: 0px !important;

}
.descriptiondialog
    {
        /* color:white !important; */
        /* background: rgb(231, 231, 231) !important; */
        /* border-top-right-radius: 100px !important; */
        /* border-bottom-left-radius: 100px !important; */
        text-decoration: none;


    }


.english-label{
    font-size: .5em;
    padding-bottom: 0px;
    margin-bottom: 0px;
    color: white;

}

.trans-label{
    font-size: 1.25em;
    padding-top: 0px;
    margin-top: 0px;
    color: white;

}

.short-code{
    font-size: 30px;
    text-transform: uppercase;
}

.business-section{
    background-color: #0A4281;
    color:white;
    font-size: 20px;
    font-weight: 600;
    text-transform: uppercase;
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
    margin-bottom: 10px;
    justify-content: left;

}
.accounts_invoices{
    background-color: #0A4281;
    color:white;
    font-size: 20px;
    font-weight: 600;
    text-transform: uppercase;
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
    margin-bottom: 10px;
    justify-content: left;

}
.user-details{
    background-color: #FE5800;
    color:white;
    font-size: 20px;
    font-weight: 600;
    text-transform: uppercase;
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
    margin-bottom: 10px;
    justify-content: left;

}
.business-activity{
    background-color: #316BAC;
    color:white;
    font-size: 20px;
    font-weight: 600;
    text-transform: uppercase;
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
    margin-bottom: 10px;
    justify-content: left;

}
.default-language-settings{
    background-color: #316BAC;
    color:white;
    font-size: 20px;
    font-weight: 600;
    text-transform: uppercase;
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
    margin-bottom: 10px;
    justify-content: left;

}
.translations{
    background-color: #FE5800;
    color:white;
    font-size: 20px;
    font-weight: 600;
    text-transform: uppercase;
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
    margin-bottom: 10px;
    justify-content: left;

}
.about_your_business{
    background-color: #316BAC;
    color:white;
    font-size: 20px;
    font-weight: 600;
    text-transform: uppercase;
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
    margin-bottom: 10px;
    justify-content: left;

}

.business-payments{
    background-color: #316BAC;
    color:white;
    font-size: 20px;
    font-weight: 600;
    text-transform: uppercase;
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
    margin-bottom: 10px;
    justify-content: left;

}
.contact-image{
    background-color: #FE5800;
    color:white;
    font-size: 20px;
    font-weight: 600;
    text-transform: uppercase;
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
    margin-bottom: 10px;
    justify-content: left;

}
.cover-image{
    background-color: #FE5800;
    color:white;
    font-size: 20px;
    font-weight: 600;
    text-transform: uppercase;
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
    margin-bottom: 10px;
    justify-content: left;

}
.business-logo{
    background-color: #FE5800;
    color:white;
    font-size: 20px;
    font-weight: 600;
    text-transform: uppercase;
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
    margin-bottom: 10px;
    justify-content: left;

}
.aforo-capacity{
    background-color: #FE5800;
    color:white;
    font-size: 20px;
    font-weight: 600;
    text-transform: uppercase;
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
    margin-bottom: 10px;
    justify-content: left;

}
.gallery{
    background-color: #FE5800;
    color:white;
    font-size: 20px;
    font-weight: 600;
    text-transform: uppercase;
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
    margin-bottom: 10px;
    justify-content: left;

}
.theme-color{
    background-color: #FE5800;
    color:white;
    font-size: 20px;
    font-weight: 600;
    text-transform: uppercase;
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
    margin-bottom: 10px;
    justify-content: left;

}
.services-provided{
    background-color: #FE5800;
    color:white;
    font-size: 20px;
    font-weight: 600;
    text-transform: uppercase;
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
    margin-bottom: 10px;
    justify-content: left;

}
.delivery-options{
    background-color: #FE5800;
    color:white;
    font-size: 20px;
    font-weight: 600;
    text-transform: uppercase;
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
    margin-bottom: 10px;
    justify-content: left;

}
.business-details{
    background-color: #316BAC;
    color:white;
    font-size: 20px;
    font-weight: 600;
    text-transform: uppercase;
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
    margin-bottom: 10px;
    justify-content: left;

}
.social-media{
    background-color: #FE5800;
    color:white;
    font-size: 20px;
    font-weight: 600;
    text-transform: uppercase;
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
    margin-bottom: 10px;
    justify-content: left;

}
.business-facilities{
    background-color: #FE5800;
    color:white;
    font-size: 20px;
    font-weight: 600;
    text-transform: uppercase;
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
    margin-bottom: 10px;
    justify-content: left;

}
.business-hours{
    background-color: #FE5800;
    color:white;
    font-size: 20px;
    font-weight: 600;
    text-transform: uppercase;
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
    margin-bottom: 10px;
    justify-content: left;

}
.dialog-title{
    color:rgb(255, 255, 255);
    font-size: 20px;
    line-height: 1;
    font-weight: 600;
    text-transform: uppercase;
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
    margin-bottom: 10px;
    justify-content: left;

}

.whatsapp-card-header{
    background-color: #4caf50;
}
.social-networks-card-header{
    background-color: #11b4e6;
}
.mid-mid{
    display: grid;
    place-items: center;
  }
.container-card-1{
display: flex;
flex-wrap: wrap;
justify-content: space-evenly;
padding-left: 5px;
padding-right: 5px;
}

.card-1 {
flex: 1 1 300px; /*  Stretching: */
/* flex: 0 1 150px;   No stretching: */
margin: 5px;
align-items: stretch;
}
.container-card-2{
display: flex;
flex-wrap: wrap;
justify-content: center;
padding-left: 5px;
padding-right: 5px;
}
.container-card-3{
display: flex;
flex-wrap: wrap;
justify-content: center;
padding-left: 5px;
padding-right: 5px;
}

.card-150 {
    display: grid;
    grid-gap: 1rem;
    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  }
.card-300 {
    display: grid;
    grid-gap: 1rem;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  }
.true-center{
  display: grid;
  place-items: center;
}
.card-header-1{
    background-color: #FE5800;
}
/* .bus-hours {
    display: grid;
    grid-gap: 1rem;
    grid-template-columns: repeat(auto-fit, minmax(100px, 100%));
  } */
  .all-to-right{
    justify-content: flex-end;
    display: flex;
    flex-wrap: wrap;
/* justify-content: space-evenly;   */
  }
  .biz-hours-container{
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
    margin: 5px;
    padding: 0px;
  }
  .biz-hours-row{
      flex: 1 1 100px;
      padding-left: 15px;
      padding-right: 15px;
      margin-left: 5px;
      margin-right: 5px;
      max-width: 200px;
      min-width: 100px;
  }
  .biz-hours-day{
      flex: 1 1 200px;
      padding-left: 15px;
      padding-right: 5px;
      margin-left: 5px;
      margin-right: 5px;
      max-width: 400px;
      min-width: 300px;
      align-self: center;
  }
  .calendar-dates{
      flex: 1 1 200px;
      padding-left: 5px;
      padding-right: 5px;
      margin-left: 5px;
      margin-right: 5px;
      max-width: 400px;
      min-width: 300px;
      align-self: center;
  }
  .info-dropdown{

      background-color:#181818;
      color:white;
      margin: 10px;
      border-radius: 5px;
      text-align: justify;
  }
.business-profile-section-heading{
    font-size: 16px;
    font-weight: 600;
    text-transform: uppercase;
    justify-content: left;

}
.capitalised{
    text-transform: capitalize;
}
</style>

